/*
  Butik Madame A — Global Theme JS
  assets/butik-global.js
  Runs on EVERY page:
    1. Replaces logo with correct brand logo everywhere
    2. Injects animated gold SVG paths on every page
    3. Polishes cart count, interactions
*/

(function () {
  'use strict';

  /* ── 1. LOGO REPLACEMENT ───────────────────────────── */
  var _logoSrc = null;

  function applyLogoToImg(img) {
    if (!_logoSrc) return;
    // Nigdy nie zastępuj zdjęć produktów — sprawdź klasę img i ancestorów
    if (img.classList.contains('resource-card__image') ||
        img.classList.contains('resource-card__placeholder') ||
        img.classList.contains('predictive-search__image')) return;
    if (img.closest('dialog, [class*="predictive-search"], [class*="search-result"], [class*="resource-item"], [class*="resource-card"]')) return;
    var alt = (img.alt || '').toLowerCase();
    var src = (img.src || '').toLowerCase();
    var srcPath = src.replace(/^https?:\/\/[^/]+/, '');
    var isLogo = alt.includes('butik') || alt.includes('madame') || alt.includes('logo') ||
                 srcPath.includes('logookrag') || srcPath.includes('logo') || srcPath.includes('madame') ||
                 (img.closest('#header-group, header, #footer-group, footer') && img.offsetHeight < 150);
    if (isLogo && img.src !== _logoSrc) {
      img.src = _logoSrc;
      img.srcset = '';
      img.sizes = '';
      /* Stare width/height opisują poprzedni obrazek — po podmianie kłamią.
         Okrągłe logo jest kwadratem, więc proporcję podajemy wprost. */
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.cssText += ';max-height:52px!important;width:auto!important;object-fit:contain!important;aspect-ratio:1/1!important;';
    }
  }

  function replaceLogo() {
    var meta = document.querySelector('meta[name="butik-logo"]');
    if (!meta) return;
    _logoSrc = meta.getAttribute('content');
    if (!_logoSrc) return;
    // :not(dialog *) ensures search modal imgs are never included
    document.querySelectorAll(
      '#header-group img:not(dialog *), header img:not(dialog *), ' +
      '#footer-group img:not(dialog *), footer img:not(dialog *), ' +
      '[class*="logo"] img:not(dialog *)'
    ).forEach(applyLogoToImg);
  }

  function watchLogo() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Skip anything inside a search/predictive-search dialog
          if (node.closest && node.closest('dialog')) return;
          if (node.tagName === 'IMG') applyLogoToImg(node);
          // Only query imgs that are NOT inside a dialog
          node.querySelectorAll && node.querySelectorAll('img:not(dialog *)').forEach(applyLogoToImg);
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function replaceLogo_withRetry() {
    replaceLogo();
    [300, 800, 1500, 3000].forEach(function (ms) {
      setTimeout(replaceLogo, ms);
    });
    watchLogo();
  }

  /* ── 2. ANIMATED GOLD PATHS (all pages) ────────────── */
  var NS = 'http://www.w3.org/2000/svg';

  function buildPath(i, pos) {
    var a = -380 - i * 5 * pos, b = -189 + i * 6,
        c = -312 - i * 5 * pos, d =  216 - i * 6,
        e =  152 - i * 5 * pos, f =  343 - i * 6,
        g =  616 - i * 5 * pos, h =  470 - i * 6,
        k =  684 - i * 5 * pos, m =  875 - i * 6;
    return 'M' + a + ' ' + b +
           ' C' + a + ' ' + b + ' ' + c + ' ' + d + ' ' + e + ' ' + f +
           ' C' + g + ' ' + h + ' ' + k + ' ' + m + ' ' + k + ' ' + m;
  }

  function makeSvg(position) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1440 900');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.setAttribute('fill', 'none');
    svg.style.overflow = 'hidden';
    svg.style.pointerEvents = 'none';
    for (var i = 0; i < 32; i++) {
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', buildPath(i, position));
      path.setAttribute('stroke', '#c9a45c');
      path.setAttribute('stroke-width', String(0.4 + i * 0.025));
      path.setAttribute('fill', 'none');
      path.style.opacity = String(Math.min(0.04 + i * 0.014, 0.35));
      svg.appendChild(path);
    }
    return svg;
  }

  function injectPaths() {
    if (document.getElementById('paths-svg-1')) return;
    if (document.querySelector('.bm-paths-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'bm-paths-wrap';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.pointerEvents = 'none';
    wrap.appendChild(makeSvg(1));
    wrap.appendChild(makeSvg(-1));

    document.body.appendChild(wrap);
  }

  /* ── 3. CART COUNT SYNC ─────────────────────────────── */
  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge, [class*="cart-count"], [class*="cart-bubble"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ── 4. COOKIE CONSENT SHADOW DOM STYLING ──────────── */
  var CONSENT_CSS = [
    '*, *::before, *::after { box-sizing: border-box; }',
    ':host > *, [class*="banner"], [class*="container"], [class*="wrapper"], [class*="modal"], div[role="dialog"] {',
    '  background: linear-gradient(135deg, #1e1d1b 0%, #252320 100%) !important;',
    '  border: 1px solid rgba(201,164,92,.25) !important;',
    '  border-radius: 6px !important;',
    '  color: rgba(255,255,255,.87) !important;',
    '  box-shadow: 0 12px 50px rgba(0,0,0,.8) !important;',
    '  font-family: "Bricolage Grotesque", sans-serif !important;',
    '}',
    'p, span, li { color: rgba(255,255,255,.6) !important; font-size: .8rem !important; line-height: 1.7 !important; }',
    'h1, h2, h3 { color: #fff !important; font-family: "Bricolage Grotesque", sans-serif !important; }',
    'a { color: #c9a45c !important; }',
    'button:not([class*="secondary"]):not([class*="decline"]):not([class*="manage"]) {',
    '  background: #c9a45c !important; color: #1a1918 !important;',
    '  border: none !important; padding: .7rem 1.5rem !important;',
    '  font-weight: 700 !important; cursor: pointer !important; border-radius: 2px !important;',
    '  font-family: "Space Mono", monospace !important; font-size: .58rem !important;',
    '  letter-spacing: .14em !important; text-transform: uppercase !important;',
    '  transition: background .2s ease !important;',
    '}',
    'button[class*="secondary"], button[class*="decline"], button[class*="manage"], button:last-child {',
    '  background: transparent !important; color: rgba(255,255,255,.5) !important;',
    '  border: 1px solid rgba(201,164,92,.3) !important; padding: .65rem 1.2rem !important;',
    '  cursor: pointer !important; border-radius: 2px !important; font-size: .58rem !important;',
    '  letter-spacing: .1em !important; text-transform: uppercase !important;',
    '}'
  ].join('\n');

  function styleConsentBanner() {
    var selectors = [
      'shopify-consent-banner', 'privacy-consent',
      'shopify-pc-banner', '[data-shopify-consent]',
      'consent-api'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.shadowRoot && !el.__bmStyled) {
          var s = document.createElement('style');
          s.textContent = CONSENT_CSS;
          el.shadowRoot.appendChild(s);
          el.__bmStyled = true;
        }
      });
    });
  }

  function watchConsentBanner() {
    var attempts = 0;
    var iv = setInterval(function () {
      styleConsentBanner();
      if (++attempts > 20) clearInterval(iv);
    }, 300);
    if (!window.MutationObserver) return;
    new MutationObserver(function () { styleConsentBanner(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ── 5. HEADER SCROLL SHADOW ───────────────────────── */
  function initHeaderScroll() {
    var header = document.getElementById('header-group');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > 30);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── 6. SMOOTH IMAGE LOAD ───────────────────────────── */
  function lazyImageFade() {
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.style.transition = 'opacity .4s ease';
      if (!img.complete) {
        img.style.opacity = '0';
        img.addEventListener('load', function () { img.style.opacity = '1'; });
      }
      obs.observe(img);
    });
  }

  /* ── ACTIVE NAV LINK + GOLD HOVER ───────────────── */
  function markActiveNav() {
    var path = window.location.pathname;
    var selectors = 'header a, #header-group a, [class*="mobile-menu"] a, [class*="drawer"] a, [class*="nav"] a';
    document.querySelectorAll(selectors).forEach(function (a) {
      if (a.closest('#bm-nav-logo-wrap')) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var isActive = href === path || (href.length > 1 && path.startsWith(href));
      if (isActive) {
        a.style.setProperty('color', '#c9a45c', 'important');
        a.style.setProperty('font-weight', '700', 'important');
      }
    });
  }

  function applyGoldNavHover() {
    document.querySelectorAll('#header-group a').forEach(function (a) {
      if (a.closest('#bm-nav-logo-wrap')) return;
      if (a._bmHover) return;
      a._bmHover = true;
      a.addEventListener('mouseenter', function () {
        a.style.setProperty('color', '#c9a45c', 'important');
      });
      a.addEventListener('mouseleave', function () {
        a.style.removeProperty('color');
        if (a.getAttribute('href') === window.location.pathname) {
          a.style.color = '#c9a45c';
        }
      });
    });
  }

  /* ── 7a. MOBILE MENU — logo hide / show ────────────── */
  function watchMobileMenu() {
    /* Przy kazdym otwarciu szuflady zdejmij ewentualny backdrop-filter
       z naglowka (inne skrypty moga go dokladac po czasie). */
    var detailsDrawer = document.querySelector('details.menu-drawer-container');
    if (detailsDrawer && !detailsDrawer._bmBackdropWatch) {
      detailsDrawer._bmBackdropWatch = true;
      detailsDrawer.addEventListener('toggle', function () {
        try { stripHeaderBackdrop(); } catch (e) {}
        try { unclipHeaderForDrawer(detailsDrawer.hasAttribute('open')); } catch (e) {}
      });
      var summary = detailsDrawer.querySelector('summary');
      if (summary) summary.addEventListener('click', function () {
        try { stripHeaderBackdrop(); } catch (e) {}
        [0, 60, 250].forEach(function (ms) {
          setTimeout(function () {
            try { stripHeaderBackdrop(); } catch (e) {}
            try { unclipHeaderForDrawer(detailsDrawer.hasAttribute('open')); } catch (e) {}
          }, ms);
        });
      });
    }

    var logo = document.getElementById('bm-nav-logo-wrap');
    if (!logo) return;

    function setLogoVisible(visible) {
      logo.style.opacity = visible ? '' : '0';
      logo.style.pointerEvents = visible ? '' : 'none';
    }

    new MutationObserver(function() {
      var menuOpen = isAnyDrawerOpen();
      setLogoVisible(!menuOpen);
    }).observe(document.documentElement, {
      attributes: true, attributeFilter: ['scroll-lock']
    });

    var menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer) {
      new MutationObserver(function() {
        setLogoVisible(!menuDrawer.hasAttribute('open'));
      }).observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
    }

    var detailsMenu = document.querySelector('details.menu-drawer-container');
    if (detailsMenu) {
      new MutationObserver(function() {
        setLogoVisible(!detailsMenu.hasAttribute('open'));
      }).observe(detailsMenu, { attributes: true, attributeFilter: ['open'] });
    }
  }

  /* ── 7. SCROLL-LOCK GUARD ───────────────────────────── */
  var _scrollLockSetAt = 0;

  function isAnyDrawerOpen() {
    return !!(
      document.querySelector('cart-drawer[open]') ||
      document.querySelector('menu-drawer[open]') ||
      document.querySelector('details[open].menu-drawer-container') ||
      document.querySelector('[class*="drawer"][open]') ||
      document.querySelector('[class*="modal"].open') ||
      document.querySelector('[class*="modal"].active') ||
      document.querySelector('[aria-modal="true"]')
    );
  }

  function releaseScrollIfSafe() {
    if (Date.now() - _scrollLockSetAt < 800) return;
    if (!isAnyDrawerOpen()) {
      document.documentElement.removeAttribute('scroll-lock');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  }

  function installScrollGuard() {
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.attributeName === 'scroll-lock') {
            if (document.documentElement.hasAttribute('scroll-lock')) {
              _scrollLockSetAt = Date.now();
            } else {
              _scrollLockSetAt = 0;
            }
          }
        });
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
    }

    window.addEventListener('load', function () {
      setTimeout(releaseScrollIfSafe, 1000);
    });
  }

  /* ── 7b. INJECT CART BUTTON ON ALL PRODUCT CARDS ─── */
  function injectCartButtons() {
    var nativeBtn = document.querySelector('quick-add-button button, .quick-add__submit, .card__add-button');
    var refSize = nativeBtn ? nativeBtn.getBoundingClientRect().width : 0;
    var btnSize = refSize > 10 ? Math.round(refSize) + 'px' : '46px';

    document.querySelectorAll('.card-wrapper, [class*="card-wrapper"]').forEach(function (card) {
      if (card.querySelector('.bm-cart-btn')) return;
      if (card.querySelector('quick-add-button, .quick-add__submit, .card__add-button')) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var imgWrap = card.querySelector('[class*="card__media"], [class*="card__image"], .card__media, .media');
      if (!imgWrap) return;

      var btn = document.createElement('a');
      btn.className = 'bm-cart-btn';
      if (nativeBtn) {
        nativeBtn.classList.forEach(function(c) {
          if (c !== 'quick-add__submit') btn.classList.add(c);
        });
      }
      btn.href = link.href;
      btn.setAttribute('aria-label', 'Dodaj do koszyka');
      btn.style.width = btnSize;
      btn.style.height = btnSize;

      var nativeIcon = nativeBtn && nativeBtn.querySelector('svg');
      if (nativeIcon) {
        btn.appendChild(nativeIcon.cloneNode(true));
      } else {
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/><line x1="17" y1="3" x2="17" y2="9"/><line x1="14" y1="6" x2="20" y2="6"/></svg>';
      }

      imgWrap.style.position = 'relative';
      imgWrap.appendChild(btn);
    });
  }

  /* ── 8. INJECT CENTRED NAV LOGO ────────────────────── */
  function injectCenteredNavLogo() {
    if (document.getElementById('bm-nav-logo-wrap')) return;

    var meta = document.querySelector('meta[name="butik-logo"]');
    if (!meta) return;
    var src = meta.getAttribute('content');
    if (!src) return;

    var headerEl = document.querySelector('#header-group, header-component');
    var headerH = headerEl ? Math.max(headerEl.offsetHeight, 44) : 64;

    var isHome = window.location.pathname === '/' || window.location.pathname === '';
    var logoPaddingTop = isHome ? '16px' : '0px';

    var wrap = document.createElement('div');
    wrap.id = 'bm-nav-logo-wrap';
    wrap.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'right:0',
      'height:' + headerH + 'px',
      'display:flex', 'align-items:center', 'justify-content:center',
      'padding-top:' + logoPaddingTop,
      'pointer-events:none',
      'z-index:9999'
    ].join(';');

    var a = document.createElement('a');
    a.id = 'bm-nav-logo';
    a.href = '/';
    a.setAttribute('aria-label', 'Strona Główna');
    var logoMargin = isHome ? '0px' : '-44px';
    a.style.cssText = 'pointer-events:auto;display:flex;align-items:center;text-decoration:none;margin-top:' + logoMargin + ';';

    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.style.cssText = 'height:44px;width:auto;max-height:44px;object-fit:contain;display:block;transition:opacity .2s ease,transform .2s cubic-bezier(.34,1.56,.64,1);';
    img.addEventListener('mouseover', function () { img.style.opacity = '.85'; img.style.transform = 'scale(1.05)'; });
    img.addEventListener('mouseout',  function () { img.style.opacity = '1';   img.style.transform = 'scale(1)';    });

    a.appendChild(img);
    wrap.appendChild(a);
    document.body.appendChild(wrap);
  }

  function injectCenteredNavLogo_withRetry() {
    injectCenteredNavLogo();
    [200, 600, 1200].forEach(function (ms) {
      setTimeout(injectCenteredNavLogo, ms);
    });
  }

  /* ── HERO BUTTONS STYLE ─────────────────────────────── */
  function styleHeroButtons() {
    var gold = '#c9a45c', goldLight = '#e2d69a';

    document.querySelectorAll('.btn-tiktok-style').forEach(function(btn) {
      if (btn._bmStyled) return;
      btn._bmStyled = true;
      btn.style.cssText += ';background:' + gold + '!important;color:#1a1918!important;border:1.5px solid ' + gold + '!important;border-radius:3px!important;box-shadow:0 4px 20px rgba(201,164,92,.35)!important;transition:background .2s ease,transform .18s cubic-bezier(.34,1.56,.64,1),box-shadow .2s ease!important;text-decoration:none!important;';
      btn.addEventListener('mouseenter', function() {
        btn.style.setProperty('background', goldLight, 'important');
        btn.style.setProperty('border-color', goldLight, 'important');
        btn.style.setProperty('transform', 'translateY(-4px)', 'important');
        btn.style.setProperty('box-shadow', '0 10px 32px rgba(201,164,92,.45)', 'important');
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.setProperty('background', gold, 'important');
        btn.style.setProperty('border-color', gold, 'important');
        btn.style.removeProperty('transform');
        btn.style.setProperty('box-shadow', '0 4px 20px rgba(201,164,92,.35)', 'important');
      });
    });

    document.querySelectorAll('.btn-facebook-style').forEach(function(btn) {
      if (btn._bmStyled) return;
      btn._bmStyled = true;
      btn.style.cssText += ';background:#1a1816!important;color:' + gold + '!important;border:1.5px solid rgba(201,164,92,.55)!important;border-radius:3px!important;box-shadow:none!important;transition:background .2s ease,border-color .2s ease,color .2s ease,transform .18s cubic-bezier(.34,1.56,.64,1),box-shadow .2s ease!important;text-decoration:none!important;';
      btn.addEventListener('mouseenter', function() {
        btn.style.setProperty('background', 'rgba(201,164,92,.15)', 'important');
        btn.style.setProperty('border-color', gold, 'important');
        btn.style.setProperty('color', gold, 'important');
        btn.style.setProperty('transform', 'translateY(-4px)', 'important');
        btn.style.setProperty('box-shadow', '0 8px 28px rgba(201,164,92,.25)', 'important');
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.setProperty('background', '#1a1816', 'important');
        btn.style.setProperty('border-color', 'rgba(201,164,92,.55)', 'important');
        btn.style.setProperty('color', gold, 'important');
        btn.style.removeProperty('transform');
        btn.style.setProperty('box-shadow', 'none', 'important');
      });
    });
  }

  /* ── FORCE HEADER FIXED na wszystkich stronach ─────────── */
  /* CSS push ma problemy z propagacją CDN — JS inline !important
     zawsze wygrywa z każdym arkuszem CSS ──────────────────── */
  /* backdrop-filter (nawet inline !important) na dowolnym przodku czyni
     z niego containing block dla position:fixed. Mobilna szuflada menu
     (.menu-drawer) jest wtedy przycinana do pudelka naglowka i praktycznie
     niewidoczna. Czyscimy to bezwarunkowo w calym naglowku. */
  function stripHeaderBackdrop() {
    var roots = document.querySelectorAll(
      '#header-group, header.header-section, header-component, header-drawer, .header__drawer'
    );
    roots.forEach(function (root) {
      var els = [root].concat([].slice.call(root.querySelectorAll('*')));
      els.forEach(function (el) {
        if (!el.style) return;
        if (el.style.backdropFilter || el.style.webkitBackdropFilter) {
          el.style.removeProperty('backdrop-filter');
          el.style.removeProperty('-webkit-backdrop-filter');
        }
      });
    });
  }

  /* Samonaprawianie: gdyby cokolwiek (np. zakeszowany starszy inline-script
     strony głównej) ponownie dodało backdrop-filter do nagłówka, zdejmij go
     natychmiast — inaczej szuflada menu znowu zostanie przycięta. */
  function watchHeaderBackdrop() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('#header-group, header.header-section').forEach(function (root) {
      if (root._bmBackdropObs) return;
      root._bmBackdropObs = true;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var el = muts[i].target;
          if (el && el.style && (el.style.backdropFilter || el.style.webkitBackdropFilter)) {
            stripHeaderBackdrop();
            return;
          }
        }
      }).observe(root, { attributes: true, attributeFilter: ['style'], subtree: true });
    });
  }

  /* Na stronie glownej Dawn wlacza tryb przezroczystego naglowka nad hero,
     ktory nadaje overflow:hidden na .header__row / .header__columns /
     .header__column oraz overflow:hidden auto na header.header-section.
     Chrome nie przycina przez to potomka position:fixed, ale Safari na iOS
     JUZ TAK - i szuflada menu byla scieta do wysokosci naglowka.
     Na czas otwarcia szuflady zdejmujemy overflow, po zamknieciu przywracamy. */
  var _bmUnclipped = [];

  function unclipHeaderForDrawer(open) {
    if (open) {
      var md = document.querySelector('.menu-drawer');
      if (!md) return;
      var el = md.parentElement;
      while (el && el.tagName !== 'BODY' && el.tagName !== 'HTML') {
        try {
          if (getComputedStyle(el).overflow !== 'visible') {
            el.style.setProperty('overflow', 'visible', 'important');
            _bmUnclipped.push(el);
          }
        } catch (e) {}
        el = el.parentElement;
      }
    } else {
      _bmUnclipped.forEach(function (el) {
        try { el.style.removeProperty('overflow'); } catch (e) {}
      });
      _bmUnclipped = [];
    }
  }

  function forceHeaderFixed() {
    var header = document.querySelector('header.header-section');
    if (!header) return;
    stripHeaderBackdrop();
    header.style.setProperty('position', 'fixed', 'important');
    header.style.setProperty('top', '0', 'important');
    header.style.setProperty('left', '0', 'important');
    header.style.setProperty('right', '0', 'important');
    header.style.setProperty('width', '100%', 'important');
    header.style.setProperty('z-index', '9999', 'important');

    /* Padding na stronach bez hero (nie homepage) */
    if (!document.body.classList.contains('template-index')) {
      var h = header.offsetHeight || 80;
      var main = document.getElementById('MainContent') || document.querySelector('.content-for-layout');
      if (main) main.style.setProperty('padding-top', h + 'px', 'important');
    }
  }

  /* ── 9b. CART DRAWER CSS INJECTION ────────────────────────
     JS-injected <style> zawsze pojawia się po Liquid {% stylesheet %}
     i wygrywa kaskadę. Targetujemy klasy Dawn 2026.
  ─────────────────────────────────────────────────────── */
  function injectCartCSS() {
    if (document.getElementById('bm-cart-injected')) return;
    var s = document.createElement('style');
    s.id = 'bm-cart-injected';
    s.textContent = [
      /* ── TŁO SZUFLADY ───────────────────────────────────── */
      '.cart-drawer__dialog{background:#0d0c0b!important;border-left:none!important;box-shadow:-40px 0 120px rgba(0,0,0,.9)!important;}',
      '.cart-drawer__inner,.cart-drawer__content{background:#0d0c0b!important;}',

      /* ── NAGŁÓWEK ──────────────────────────────────────── */
      '.cart-drawer__header{background:#0d0c0b!important;border-bottom:1px solid rgba(201,164,92,.12)!important;padding:1rem 1.25rem!important;display:flex!important;align-items:center!important;justify-content:space-between!important;}',
      '.cart-drawer__heading{font-family:"Bricolage Grotesque",sans-serif!important;font-size:1.1rem!important;font-weight:700!important;letter-spacing:-.02em!important;color:#fff!important;}',
      '.cart-drawer__heading .cart-bubble{background:rgba(201,164,92,.22)!important;color:#c9a45c!important;font-family:"Space Mono",monospace!important;font-size:.52rem!important;border-radius:3px!important;padding:2px 8px!important;font-weight:700!important;}',
      /* Przycisk zamknij — goły złoty X, wyrównany z napisem "Koszyk".
         Dawn: .close-button{position:fixed;top/right:var(--margin-lg)} — dlatego
         X wisiał w rogu ekranu zamiast siedzieć w nagłówku szuflady. */
      'html body #header-group .cart-drawer__close-button,html body .cart-drawer__close-button{position:static!important;color:#c9a45c!important;background:none!important;border:none!important;border-radius:0!important;width:30px!important;height:30px!important;min-width:0!important;min-height:0!important;flex:0 0 auto!important;display:flex!important;align-items:center!important;justify-content:center!important;cursor:pointer!important;touch-action:manipulation!important;box-shadow:none!important;padding:0!important;margin:0!important;}',
      'html body #header-group .cart-drawer__close-button,html body .cart-drawer__close-button{opacity:1!important;visibility:visible!important;animation:none!important;}',
      'html body #header-group .cart-drawer__close-button:hover,html body .cart-drawer__close-button:hover{background:none!important;color:#e2d69a!important;transform:scale(1.12)!important;}',
      'html body #header-group .cart-drawer__close-button svg,html body .cart-drawer__close-button svg{stroke:currentColor!important;width:17px!important;height:17px!important;stroke-width:2!important;}',
      'html body #header-group .cart-drawer__close-button svg path,html body .cart-drawer__close-button svg path{stroke:currentColor!important;stroke-width:2!important;}',

      /* ── LISTA PRODUKTÓW ───────────────────────────────── */
      '.cart-items__wrapper{padding:1rem 1.1rem 1.1rem!important;}',
      '.cart-items__table{display:block!important;width:100%!important;}',
      '.cart-items__table>thead,.cart-items__table>tbody{display:block!important;width:100%!important;}',
      '.cart-items__table>thead{height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;}',

      /* ── KARTA PRODUKTU ──────────────────────────────────── */
      '.cart-items__table-row{display:grid!important;width:100%!important;box-sizing:border-box!important;grid-template-columns:90px minmax(0,1fr) auto!important;grid-template-areas:"media details price" "media variants quantity" "media error error"!important;grid-template-rows:auto auto min-content!important;column-gap:.9rem!important;row-gap:0!important;background:rgba(255,255,255,.04)!important;border:none!important;border-radius:10px!important;padding:.9rem 1rem!important;margin-bottom:.6rem!important;box-shadow:0 2px 12px rgba(0,0,0,.3)!important;}',
      '.cart-drawer .cart-items__table-row--full-width-variants{grid-template-columns:90px minmax(0,1fr) auto!important;grid-template-areas:"media details price" "media variants quantity" "media error error"!important;}',
      '.cart-items__table-row:last-child{margin-bottom:0!important;}',

      /* ── MINIATURA — 90×90 ─────────────────────────────── */
      '.cart-items__media{grid-area:media!important;align-self:stretch!important;padding:0!important;}',
      '.cart-items__media-container{position:relative!important;display:block!important;width:90px!important;height:90px!important;min-width:90px!important;max-width:90px!important;overflow:hidden!important;border-radius:6px!important;border:none!important;background:rgba(255,255,255,.06)!important;}',
      '.cart-items__media-image{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center center!important;border:none!important;}',

      /* ── GRID AREA ─────────────────────────────────────── */
      '.cart-items__product-info{margin:0!important;padding:0!important;align-self:center!important;}',
      '.cart-items__variants-wrapper{grid-area:variants!important;margin:0!important;padding:0!important;align-self:center!important;}',
      '.cart-items__unit-price-wrapper{display:none!important;}',
      '.cart-items__price{grid-area:price!important;align-self:center!important;text-align:end!important;min-width:auto!important;}',
      '.cart-items__quantity{grid-area:quantity!important;align-self:center!important;justify-self:end!important;margin:0!important;}',

      /* Usuń linie strukturalne */
      '.cart-drawer__inner,.cart-drawer__content,.cart-drawer__items,scroll-hint{border:none!important;box-shadow:none!important;}',
      '.cart-items__table-row *{border-top:none!important;border-bottom:none!important;}',

      /* ── TYTUŁ ─────────────────────────────────────────── */
      '.cart-items__title{color:rgba(255,255,255,.95)!important;font-family:"Bricolage Grotesque",sans-serif!important;font-size:.92rem!important;font-weight:700!important;line-height:1.3!important;letter-spacing:-.01em!important;text-decoration:none!important;display:block!important;margin:0!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
      '.cart-items__title:hover{color:#c9a45c!important;}',

      /* ── WARIANT ───────────────────────────────────────── */
      '.cart-items__variants,.cart-items__variant,.cart-items__variant dd,.cart-items__variant dt{color:rgba(255,255,255,.38)!important;font-family:"Space Mono",monospace!important;font-size:.58rem!important;letter-spacing:.04em!important;margin:0!important;}',

      /* ── CENA — złota ──────────────────────────────────── */
      '.cart-items__price,.cart-items__price text-component{color:#c9a45c!important;font-family:"Space Mono",monospace!important;font-size:.86rem!important;font-weight:700!important;white-space:nowrap!important;letter-spacing:.01em!important;}',

      /* ── KONTROLER ILOŚCI ─────────────────────────────────── */
      'dialog.cart-drawer__dialog{--color-input-background:transparent!important;--color-input-hover-background:transparent!important;--color-input-border:transparent!important;--style-border-radius-inputs:0px!important;--style-border-width-inputs:0px!important;}',
      '.cart-items__quantity-controls{display:flex!important;align-items:center!important;gap:2px!important;padding:0!important;background:transparent!important;border:none!important;}',
      '.cart-items .quantity-selector-wrapper,.cart-drawer .quantity-selector-wrapper{background:transparent!important;background-color:transparent!important;border:none!important;}',
      'cart-quantity-selector-component,.cart-items .quantity-selector,.cart-drawer .quantity-selector{background:transparent!important;background-color:transparent!important;border:none!important;border-radius:0!important;box-shadow:none!important;height:36px!important;min-width:70px!important;width:70px!important;flex:0 0 70px!important;display:inline-flex!important;align-items:center!important;}',
      '.cart-items .quantity-selector button,.cart-drawer .quantity-selector button,.quantity-minus,.quantity-plus{color:rgba(255,255,255,.5)!important;background:transparent!important;background-color:transparent!important;border:none!important;box-shadow:none!important;min-width:32px!important;width:32px!important;height:36px!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;flex-shrink:0!important;pointer-events:auto!important;cursor:pointer!important;z-index:2!important;position:relative!important;touch-action:manipulation!important;}',
      '.cart-items .quantity-selector button:hover,.quantity-minus:hover,.quantity-plus:hover{color:#c9a45c!important;}',
      '.cart-items .quantity-selector button svg,.quantity-minus svg,.quantity-plus svg{width:14px!important;height:14px!important;}',
      '.cart-items .quantity-selector input,.cart-drawer .quantity-selector input{background:transparent!important;background-color:transparent!important;border:none!important;color:rgba(255,255,255,.9)!important;font-family:"Space Mono",monospace!important;font-size:.78rem!important;font-weight:700!important;text-align:center!important;width:22px!important;padding:0!important;pointer-events:none!important;}',

      /* ── KOSZ ─────────────────────────────────────────── */
      '.cart-items__remove{color:rgba(255,255,255,.3)!important;background:transparent!important;background-color:transparent!important;border:none!important;box-shadow:none!important;min-width:32px!important;width:32px!important;height:32px!important;padding:0!important;margin-left:4px!important;display:flex!important;align-items:center!important;justify-content:center!important;flex-shrink:0!important;pointer-events:auto!important;cursor:pointer!important;touch-action:manipulation!important;}',
      '.cart-items__remove:hover{color:rgba(210,50,50,.85)!important;}',
      '.cart-items__remove svg{stroke:currentColor!important;fill:none!important;width:14px!important;height:14px!important;}',

      /* ── SEKCJA SUMY — zero linii ─────────────────────── */
      '.cart-drawer__summary{background:#0d0c0b!important;border:none!important;border-top:1px solid rgba(255,255,255,.05)!important;}',
      '.cart-drawer__summary .cart-totals{padding:1.3rem 1.5rem .7rem!important;gap:.5rem!important;}',
      '.cart-drawer__summary .cart__ctas{padding:.6rem 1.5rem 1.3rem!important;}',
      '.cart-actions,.cart-actions *,.cart-totals,.cart-totals *,.cart__summary-totals,.cart__summary-totals *{border:none!important;border-top:none!important;border-bottom:none!important;}',

      /* ── RABAT ─────────────────────────────────────────────
         Powód przebudowy: .cart-totals jest kolumnowym flexem z
         align-items:baseline, więc .cart-actions/.cart-discount kurczyły się
         do szerokości treści (52 px!). Napis "ZNIŻKA" i ikona "+" nachodziły
         wtedy na siebie, a w sekcję trudno było trafić. Stąd stretch
         + jawne width:100% na całym łańcuchu. */
      'html body .cart-drawer__summary .cart-totals{align-items:stretch!important;gap:.85rem!important;}',
      'html body .cart-drawer__summary .cart-actions,html body .cart-drawer__summary .cart-actions>*{width:100%!important;}',
      /* .cart-actions ma własny padding 0 25.5px, a .cart-totals i .cart-drawer__summary
         też po 25.5px — panel rabatu był przez to wcięty względem wiersza sumy. */
      'html body .cart-drawer__summary .cart-actions{padding-left:0!important;padding-right:0!important;box-sizing:border-box!important;}',
      'html body .cart-discount{width:100%!important;display:block!important;border:1px solid rgba(201,164,92,.2)!important;border-radius:8px!important;background:rgba(201,164,92,.035)!important;overflow:hidden!important;}',
      'html body .cart-discount>.details,html body .cart-discount details{width:100%!important;}',
      /* pasek nagłówka rozwijanego — cały klikalny */
      'html body .cart-discount__summary{width:100%!important;box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:space-between!important;gap:.75rem!important;padding:.8rem 1rem!important;margin:0!important;cursor:pointer!important;list-style:none!important;transition:background .2s ease!important;}',
      'html body .cart-discount__summary::-webkit-details-marker{display:none!important;}',
      'html body .cart-discount__summary::marker{content:""!important;}',
      'html body .cart-discount__summary:hover{background:rgba(201,164,92,.08)!important;}',
      'html body .cart-discount__label{color:#c9a45c!important;font-family:"Space Mono",monospace!important;font-size:11px!important;letter-spacing:.18em!important;text-transform:uppercase!important;white-space:nowrap!important;}',
      'html body .cart-discount .cart-totals__icon{color:#c9a45c!important;flex:0 0 auto!important;width:14px!important;height:14px!important;transition:transform .2s ease!important;}',
      'html body .cart-discount details[open] .cart-totals__icon{transform:rotate(45deg)!important;}',
      /* formularz kodu */
      'html body .cart-discount__content{padding:.2rem 1rem 1rem!important;}',
      'html body .cart-discount__form{display:flex!important;align-items:stretch!important;gap:.5rem!important;width:100%!important;min-height:44px!important;}',
      'html body .cart-discount__input{flex:1 1 auto!important;min-width:0!important;width:auto!important;background:rgba(255,255,255,.05)!important;border:1px solid rgba(255,255,255,.12)!important;border-radius:6px!important;color:#fff!important;font-family:"Space Mono",monospace!important;font-size:14px!important;letter-spacing:.06em!important;padding:0 .8rem!important;height:44px!important;box-shadow:none!important;}',
      'html body .cart-discount__input::placeholder{color:rgba(255,255,255,.32)!important;letter-spacing:.04em!important;}',
      'html body .cart-discount__input:focus,html body .cart-discount__input:focus-visible{border-color:rgba(201,164,92,.55)!important;outline:none!important;box-shadow:0 0 0 2px rgba(201,164,92,.16)!important;}',
      'html body .cart-discount__button{flex:0 0 auto!important;width:auto!important;background:rgba(201,164,92,.16)!important;border:1px solid rgba(201,164,92,.42)!important;color:#c9a45c!important;border-radius:6px!important;font-family:"Space Mono",monospace!important;font-size:10px!important;letter-spacing:.16em!important;text-transform:uppercase!important;font-weight:700!important;height:44px!important;min-height:0!important;padding:0 1.1rem!important;cursor:pointer!important;box-shadow:none!important;transition:background .2s ease,color .2s ease!important;}',
      'html body .cart-discount__button:hover{background:rgba(201,164,92,.3)!important;color:#e2d69a!important;}',
      /* komunikat błędu — czytelny, ale nadal chowany klasą .hidden */
      'html body .cart-discount__error{display:flex!important;align-items:flex-start!important;gap:.5rem!important;padding:0 1rem .9rem!important;}',
      'html body .cart-discount__error.hidden{display:none!important;}',
      'html body .cart-discount__error .svg-wrapper,html body .cart-discount__error svg{flex:0 0 auto!important;width:13px!important;height:13px!important;margin-top:.15rem!important;}',
      'html body .cart-discount__error-text{color:rgba(255,150,150,.92)!important;font-family:"Space Mono",monospace!important;font-size:12px!important;line-height:1.5!important;letter-spacing:.02em!important;}',
      'html body .cart-discount__error-text.hidden{display:none!important;}',
      /* lista zastosowanych kodów */
      'html body .cart-discount__codes{display:flex!important;flex-wrap:wrap!important;gap:.4rem!important;list-style:none!important;margin:0!important;padding:0 1rem .9rem!important;}',
      'html body .cart-discount__codes:empty{display:none!important;padding:0!important;}',
      'html body .cart-discount__codes li{background:rgba(201,164,92,.16)!important;border:1px solid rgba(201,164,92,.35)!important;border-radius:4px!important;color:#c9a45c!important;font-family:"Space Mono",monospace!important;font-size:11px!important;padding:.25rem .55rem!important;display:inline-flex!important;align-items:center!important;gap:.35rem!important;}',
      /* Szuflada koszyka siedzi w #header-group, a tam działają reguły z ID:
         `#header-group input/summary { background: transparent !important }` oraz
         `#header-group button { color: var(--bm-muted) !important }`.
         Selektor z ID (1,0,1) bije klasowy (0,1,2) niezależnie od kolejności —
         stąd te same reguły jeszcze raz z prefiksem #header-group. */
      'html body #header-group .cart-discount__summary:hover{background:rgba(201,164,92,.08)!important;}',
      'html body #header-group .cart-discount__input{background:rgba(255,255,255,.05)!important;background-color:rgba(255,255,255,.05)!important;color:#fff!important;}',
      'html body #header-group .cart-discount__input:focus,html body #header-group .cart-discount__input:focus-visible{border-color:rgba(201,164,92,.55)!important;box-shadow:0 0 0 2px rgba(201,164,92,.16)!important;}',
      'html body #header-group .cart-discount__button{background:rgba(201,164,92,.16)!important;background-color:rgba(201,164,92,.16)!important;color:#c9a45c!important;border:1px solid rgba(201,164,92,.42)!important;}',
      'html body #header-group .cart-discount__button:hover{background:rgba(201,164,92,.3)!important;background-color:rgba(201,164,92,.3)!important;color:#e2d69a!important;}',
      'html body #header-group .cart-discount__label{color:#c9a45c!important;}',
      'html body #header-group .cart-discount .cart-totals__icon{color:#c9a45c!important;}',

      /* ── SUMA CAŁKOWITA ────────────────────────────────── */
      'html body .cart-totals__total{width:100%!important;display:flex!important;align-items:baseline!important;justify-content:space-between!important;gap:1rem!important;}',
      '.cart-totals__total-label{font-family:"Space Mono",monospace!important;font-size:.55rem!important;letter-spacing:.18em!important;text-transform:uppercase!important;color:rgba(255,255,255,.45)!important;}',
      '.cart-totals__total-value{font-family:"Space Mono",monospace!important;font-size:1.35rem!important;font-weight:700!important;color:#c9a45c!important;letter-spacing:-.03em!important;text-shadow:0 0 24px rgba(201,164,92,.4)!important;}',
      '.cart-totals__tax-note,.cart-totals__tax-note small{color:rgba(255,255,255,.18)!important;font-size:.51rem!important;line-height:1.5!important;}',

      /* ── PRZYCISK ZAKUPU — zawsze złoty ────────────────── */
      '.cart__checkout-button,#checkout{background:linear-gradient(135deg,#d4b06a 0%,#c9a45c 55%,#b8894a 100%)!important;color:#0a0908!important;font-family:"Space Mono",monospace!important;font-size:.54rem!important;letter-spacing:.24em!important;text-transform:uppercase!important;font-weight:700!important;border:none!important;border-radius:6px!important;height:52px!important;width:100%!important;box-shadow:0 4px 28px rgba(201,164,92,.4)!important;cursor:pointer!important;}',
      '.cart__checkout-button:hover,#checkout:hover{background:linear-gradient(135deg,#dfc07a 0%,#d4b06a 55%,#c49a5e 100%)!important;box-shadow:0 8px 36px rgba(201,164,92,.55)!important;}',

      /* ── PUSTY KOSZYK ──────────────────────────────────── */
      '.cart-drawer__heading--empty{font-family:"Bricolage Grotesque",sans-serif!important;color:rgba(255,255,255,.3)!important;}',
      'html body #header-group .cart-items__empty-button,html body .cart-items__empty-button{background:#c9a45c!important;color:#1a1918!important;border:none!important;border-radius:4px!important;font-family:"Space Mono",monospace!important;font-size:.66rem!important;font-weight:700!important;letter-spacing:.2em!important;text-transform:uppercase!important;padding:1rem 2rem!important;min-height:3.1rem!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;box-shadow:0 4px 20px rgba(201,164,92,.25)!important;}',
      'html body #header-group .cart-items__empty-button .button-text,html body .cart-items__empty-button .button-text{color:#1a1918!important;}',
      'html body #header-group .cart-items__empty-button:hover,html body .cart-items__empty-button:hover{background:#e2d69a!important;color:#1a1918!important;transform:translateY(-2px)!important;}',
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── 9a. SEARCH MODAL CSS INJECTION ──────────────────────
     Wstrzykujemy CSS przez JS żeby ominąć CDN HTML cache.
     Działa nawet gdy bm-styles.css nie ładuje się (stary ?v= hash).
  ─────────────────────────────────────────────────────── */
  function injectSearchModalCSS() {
    if (document.getElementById('bm-search-modal-injected')) return;
    var s = document.createElement('style');
    s.id = 'bm-search-modal-injected';
    s.textContent = [
      /* Reset złego centrowania — stary kod dawał translateX(-50%) */
      'dialog.search-modal__content{background:#0e0d0b!important;border:none!important;border-bottom:1px solid rgba(201,164,92,.18)!important;box-shadow:0 32px 80px rgba(0,0,0,.7)!important;}',
      'dialog.search-modal__content>*,dialog.search-modal__content predictive-search-component,dialog.search-modal__content form.predictive-search-form{transform:none!important;left:auto!important;position:relative!important;width:100%!important;margin-left:0!important;margin-right:0!important;}',
      /* Siatka wyników */
      'dialog.search-modal__content .predictive-search-results__list{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;padding:10px!important;list-style:none!important;margin:0!important;}',
      /* Karta — stop animacjom szkieletu (skeleton loader) */
      'dialog.search-modal__content .resource-card{opacity:1!important;animation:none!important;background:rgba(255,255,255,.035)!important;border:1px solid rgba(201,164,92,.1)!important;border-radius:4px!important;overflow:hidden!important;row-gap:0!important;}',
      'dialog.search-modal__content .resource-card *{animation:none!important;}',
      'dialog.search-modal__content .resource-card__title,dialog.search-modal__content product-title,dialog.search-modal__content .resource-card [class*="title"]{background:transparent!important;background-color:transparent!important;animation:none!important;}',
      /* KRYTYCZNE: link musi być transparent — bez tego zasłania całą kartę */
      'dialog.search-modal__content .resource-card__link{position:absolute!important;inset:0!important;z-index:2!important;background:transparent!important;}',
      /* Placeholder ikona zamiast tekstu */
      'dialog.search-modal__content .resource-card__image-placeholder{display:flex!important;align-items:center!important;justify-content:center!important;background:rgba(201,164,92,.05)!important;font-size:0!important;color:transparent!important;position:relative!important;min-height:130px!important;aspect-ratio:4/5!important;}',
      /* Treść karty */
      'dialog.search-modal__content .resource-card__content{padding:9px 10px 11px!important;background:#0e0d0b!important;gap:3px!important;display:flex!important;flex-direction:column!important;}',
      /* Tytuł */
      'dialog.search-modal__content .resource-card__title{color:#f0ece4!important;font-family:"Bricolage Grotesque",sans-serif!important;font-size:.8rem!important;font-weight:500!important;line-height:1.3!important;margin:0!important;background:transparent!important;}',
      /* Cena */
      '.price__hidden{display:none!important;}',
      'dialog.search-modal__content .resource-card__price,dialog.search-modal__content .price,dialog.search-modal__content [class*="price"]{background:transparent!important;}',
      'dialog.search-modal__content .price__regular .price,dialog.search-modal__content .price-item--sale.price{color:#c9a45c!important;font-family:"Space Mono",monospace!important;font-size:.72rem!important;font-weight:400!important;background:transparent!important;}',
      /* Modal background — [class*=modal] NIE może przykrywać dialog */
      '[class*="modal"]:not(dialog.search-modal__content),[class*="overlay"]{background-color:rgba(26,25,24,.96)!important;border-color:rgba(201,164,92,.22)!important;}',
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── 9. SEARCH MODAL IMAGE FIX ────────────────────────── */
  function fixSearchModalImages() {
    var dialog = document.querySelector('dialog.search-modal__content');
    if (!dialog) { setTimeout(fixSearchModalImages, 600); return; }

    function forceImages() {
      dialog.querySelectorAll('img').forEach(function(img) {
        img.style.setProperty('opacity', '1', 'important');
        img.style.setProperty('transition', 'none', 'important');
        try { img.loading = 'eager'; } catch(e) {}
        var dataSrc = img.getAttribute('data-src');
        if (dataSrc && img.src !== dataSrc) img.src = dataSrc;
        var dataSrcset = img.getAttribute('data-srcset');
        if (dataSrcset) img.srcset = dataSrcset;
      });
      // Undo any logo-replacement sizing on product card imgs (applyLogoToImg may
      // fire first for imgs whose filename contains 'logo' — e.g. a product using
      // logo-okragle.png as its actual product image)
      dialog.querySelectorAll('.resource-card img').forEach(function(img) {
        img.style.setProperty('max-height', 'none', 'important');
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('height', '100%', 'important');
        img.style.setProperty('object-fit', 'cover', 'important');
      });
    }

    new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'open' && dialog.hasAttribute('open')) {
          forceImages();
          [150, 400, 800].forEach(function(t) { setTimeout(forceImages, t); });
        }
      });
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

    new MutationObserver(function() {
      if (dialog.hasAttribute('open')) forceImages();
    }).observe(dialog, { childList: true, subtree: true });
  }

  /* ── 10. KOSZYK — przycisk ZAWSZE złoty ───────────────────
     Wywołujemy bez guard _bmCarted — żeby zawsze był złoty.
     Event listenery dodajemy tylko raz dzięki _bmListeners.
  ───────────────────────────────────────────────────── */
  function styleCartButton() {
    var btn = document.querySelector('.cart__checkout-button, #checkout');
    if (!btn) return;
    var GR = 'linear-gradient(135deg,#d4b06a 0%,#c9a45c 55%,#b8894a 100%)';
    var GRH = 'linear-gradient(135deg,#dfc07a 0%,#d4b06a 55%,#c49a5e 100%)';
    var DARK = '#0a0908';
    /* Zawsze nadpisuj styl — żeby button był złoty */
    btn.style.setProperty('background', GR, 'important');
    btn.style.setProperty('color', DARK, 'important');
    btn.style.setProperty('font-family', '"Space Mono", monospace', 'important');
    btn.style.setProperty('font-size', '.54rem', 'important');
    btn.style.setProperty('letter-spacing', '.24em', 'important');
    btn.style.setProperty('text-transform', 'uppercase', 'important');
    btn.style.setProperty('font-weight', '700', 'important');
    btn.style.setProperty('border', 'none', 'important');
    btn.style.setProperty('border-radius', '4px', 'important');
    btn.style.setProperty('height', '52px', 'important');
    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('box-shadow', '0 4px 28px rgba(201,164,92,.4), 0 1px 6px rgba(0,0,0,.5)', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    /* Event listenery tylko raz */
    if (!btn._bmListeners) {
      btn._bmListeners = true;
      btn.addEventListener('mouseenter', function() {
        btn.style.setProperty('background', GRH, 'important');
        btn.style.setProperty('box-shadow', '0 8px 36px rgba(201,164,92,.55), 0 2px 8px rgba(0,0,0,.5)', 'important');
        btn.style.setProperty('transform', 'translateY(-2px)', 'important');
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.setProperty('background', GR, 'important');
        btn.style.setProperty('box-shadow', '0 4px 28px rgba(201,164,92,.4), 0 1px 6px rgba(0,0,0,.5)', 'important');
        btn.style.setProperty('transform', 'translateY(0)', 'important');
      });
    }
  }

  /* ── INLINE STYLES — pokonują base.css bez !important ──── */
  function forceCartStyles() {
    /* --color-border = transparent w całej szufladzie */
    var dialog = document.querySelector('dialog.cart-drawer__dialog, .cart-drawer__dialog');
    if (dialog) {
      dialog.style.setProperty('--color-border', 'transparent');
      dialog.style.setProperty('--bm-gold-border', 'transparent');
    }
    /* Selector ilości — transparent background */
    var CARD_BG = 'transparent';
    var qSelectors = [
      '.cart-items__quantity',
      '.cart-items__quantity-controls',
      '.quantity-selector-wrapper',
      'cart-quantity-selector-component',
      '.cart-items .quantity-selector',
      '.cart-drawer .quantity-selector',
    ];
    qSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('background', CARD_BG, 'important');
        el.style.setProperty('background-color', CARD_BG, 'important');
        el.style.setProperty('border', 'none', 'important');
        el.style.setProperty('box-shadow', 'none', 'important');
        el.style.setProperty('border-radius', '0', 'important');
      });
    });
    /* Input — biały tekst */
    document.querySelectorAll('.cart-items .quantity-selector input').forEach(function(inp) {
      inp.style.setProperty('color', 'rgba(255,255,255,.9)', 'important');
      inp.style.setProperty('background', 'transparent', 'important');
      inp.style.setProperty('border', 'none', 'important');
    });
    /* Sekcja rabatu i sum — usuń wszystkie linie */
    document.querySelectorAll('.cart-actions, .cart-totals, [class*="cart-summary"]').forEach(function(el) {
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-top', 'none', 'important');
      el.style.setProperty('border-bottom', 'none', 'important');
    });
  }

  /* ── PRZYCISKI +/− — bezpośrednie event listenery ──────
     Działają niezależnie od Dawn custom element.
     Zmieniamy wartość inputa i wysyłamy request do Shopify.
  ─────────────────────────────────────────────────────── */
  /* ── PRZYCISKI +/− W KOSZYKU ─────────────────────────────
     Kontekst: plik motywu `component-cart-quantity-selector.js` jest pustą
     zaślepką, więc komponent `cart-quantity-selector-component` NIE jest
     zarejestrowany i deklaratywny handler Dawn `on:click="/increaseQuantity"`
     jest martwy. Na karcie produktu komponent `quantity-selector-component`
     działa normalnie.

     Stąd dwa błędy, które ten kod naprawia:
       • karta produktu — nasz stary handler dokładał się do żywego handlera
         Dawn i ilość rosła o 2 zamiast o 1,
       • koszyk — stary handler zmieniał tylko wartość w polu, a serwer nigdy
         się o tym nie dowiadywał (klientka widziała 2, kupowała 1).

     Rozwiązanie: wchodzimy WYŁĄCZNIE tam, gdzie komponent Dawn jest martwy,
     i zapisujemy zmianę przez /cart/change.js. Gdy motyw zostanie kiedyś
     naprawiony, `customElements.get(...)` zwróci komponent i nasz kod sam się
     wyłączy — bez ryzyka powrotu podwójnego zliczania.
  ─────────────────────────────────────────────────────── */
  var _bmCartBusy = false;

  function bmCartSectionId() {
    var el = document.querySelector('cart-items-component[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function bmUpdateCartBubbles(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      var t = b.querySelector('[ref="cartBubbleText"], .cart-bubble__text');
      (t || b).textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });
  }

  /* Podmienia tylko listę pozycji i podsumowanie — nie cały nagłówek,
     żeby nie zresetować naszych własnych elementów (logo, style koszyka). */
  function bmSwapCartMarkup(html) {
    if (!html) return false;
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return false; }
    var swapped = false;
    ['.cart-items__wrapper', '.cart-totals'].forEach(function (sel) {
      var fresh = doc.querySelector(sel);
      var live = document.querySelector(sel);
      if (fresh && live) { live.innerHTML = fresh.innerHTML; swapped = true; }
    });
    return swapped;
  }

  /* Dla okienka propozycji (bmUpsell niżej): po dodaniu produktu odświeża
     listę i sumę koszyka pod spodem tak samo, jak nasza ścieżka +/−. */
  window.bmCartSync = function (html, count) {
    if (typeof count === 'number') bmUpdateCartBubbles(count);
    if (!bmSwapCartMarkup(html)) return;
    try { forceCartStyles(); } catch (e) {}
    try { bindQuantityButtons(); } catch (e) {}
  };

  function bmCartChange(line, quantity, input) {
    if (_bmCartBusy) return;
    _bmCartBusy = true;

    var sectionId = bmCartSectionId();
    var body = { line: line, quantity: quantity };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count === 'undefined') return;
        bmUpdateCartBubbles(cart.item_count);
        var html = cart.sections && sectionId ? cart.sections[sectionId] : null;
        if (!bmSwapCartMarkup(html) && input) {
          /* Awaryjnie: serwer ma poprawny stan, odśwież przynajmniej pole. */
          input.value = quantity;
        }
        try { forceCartStyles(); } catch (e) {}
        try { bindQuantityButtons(); } catch (e) {}
      })
      .catch(function () {
        if (input) input.value = input.getAttribute('value') || input.value;
      })
      .then(function () { _bmCartBusy = false; });
  }

  /* ── KASOWANIE POZYCJI: znikały DWA wiersze zamiast jednego ──────────
     Zgłoszone 2026-08-29 razem ze złotymi kreskami.

     Mechanizm (błąd wyścigu w samym Dawn, `component-cart-items.js` NIE
     jest zaślepką — to działający kod):

       onLineItemRemove(line) {
         this.updateQuantity(...)            // fetch, asynchronicznie
         const wiersz = this.refs.cartItemRows[line - 1];
         wiersz.classList.add('removing');
         onAnimationEnd(wiersz, () => wiersz.remove());   // ~300 ms PÓŹNIEJ
       }

     Zanim animacja dobiegnie końca, odpowiedź z serwera odpala
     `morphSection()`, a morfowanie ŚWIADOMIE ponownie używa istniejących
     węzłów DOM. Trzymany w domknięciu `wiersz` bywa wtedy już węzłem
     INNEJ pozycji — i spóźnione `.remove()` kasuje niewinny wiersz.

     Pomiar: koszyk z 3 pozycjami, kasowana 1. Serwer: 3 → 2 (poprawnie).
     DOM: 3 → 1. Klientka widziała, że zniknęły dwa produkty naraz.

     Nie ruszamy pliku Dawn — po zdarzeniu `cart:update` odczekujemy, aż
     animacja się skończy, i porównujemy liczbę wierszy w DOM ze stanem
     serwera. Gdy się nie zgadza, dociągamy świeży HTML sekcji i podmieniamy
     listę. Przy poprawnym przebiegu (a więc prawie zawsze) nie leci ANI
     JEDNO dodatkowe żądanie — samo porównanie liczb.

     Gdy Shopify kiedyś naprawi ten wyścig, ten kod przestanie cokolwiek
     robić sam z siebie: warunek `wDom !== cart.items.length` będzie fałszywy.
  ─────────────────────────────────────────────────────────────────────── */
  var _bmHealTimery = [];
  var _bmHealHtml = null;         /* świeży HTML sekcji prosto ze zdarzenia */
  var _bmHealOczekiwane = null;   /* ile wierszy POWINNO być — policzone raz */

  function bmPoliczWierszeKoszyka(korzen) {
    /* tbody, żeby nie łapać ukrytego wiersza nagłówka z <thead> */
    return (korzen || document).querySelectorAll('.cart-items__table tbody tr').length;
  }

  function bmSekcjaKoszyka() {
    var el = document.querySelector('cart-items-component[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function bmHealCartList() {
    if (!document.querySelector('cart-items-component')) return;
    if (!document.querySelector('.cart-items__table tbody')) return;   /* pusty koszyk */

    /* Ścieżka bez sieci: Dawn dołącza świeży HTML sekcji do zdarzenia.
       Liczbę wierszy z tego HTML-a liczymy RAZ (parsowanie ~190 KB nie jest
       darmowe), a kolejne sprawdzenia to już samo porównanie liczb. */
    if (_bmHealHtml && _bmHealOczekiwane !== null) {
      if (_bmHealOczekiwane !== bmPoliczWierszeKoszyka()) {
        if (bmSwapCartMarkup(_bmHealHtml)) {
          try { forceCartStyles(); } catch (e) {}
          try { bindQuantityButtons(); } catch (e) {}
        }
      }
      return;
    }

    /* Zapas na wypadek zdarzenia bez sekcji (np. nasza własna ścieżka +/−).
       Pusty `updates` nie zmienia koszyka, a odpowiedź niesie świeży HTML. */
    var sectionId = bmSekcjaKoszyka();
    if (!sectionId) return;
    var wDom = bmPoliczWierszeKoszyka();

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === wDom) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: {}, sections: sectionId, sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (odp) {
            var html = odp && odp.sections ? odp.sections[sectionId] : null;
            if (!bmSwapCartMarkup(html)) return;
            try { forceCartStyles(); } catch (e) {}
            try { bindQuantityButtons(); } catch (e) {}
          });
      })
      .catch(function () { /* bez sieci zostawiamy listę jak jest */ });
  }

  function bmWatchCartRemoval() {
    document.addEventListener('cart:update', function (e) {
      var sekcje = e && e.detail && e.detail.data ? e.detail.data.sections : null;
      var id = bmSekcjaKoszyka();
      _bmHealHtml = (sekcje && id && sekcje[id]) ? sekcje[id] : null;
      _bmHealOczekiwane = null;

      if (_bmHealHtml) {
        try {
          _bmHealOczekiwane = bmPoliczWierszeKoszyka(
            new DOMParser().parseFromString(_bmHealHtml, 'text/html')
          );
        } catch (err) { _bmHealHtml = null; }
      }

      /* KIEDY sprawdzać: pomiar na żywo (2026-08-29) pokazał, że Dawn
         najpierw wstawia poprawną listę w ~580 ms, a spóźnione `.remove()`
         wycina wiersz dopiero w ~666 ms. Jedno sprawdzenie było więc albo
         za wczesne, albo zostawiało widoczną dziurę na pół sekundy.
         Stąd seria: pierwsze tuż po animacji (`--animation-speed` 0,125 s
         × 3 = 375 ms), kolejne z zapasem na wolniejszy telefon.
         Każde poza pierwszym to samo porównanie dwóch liczb. */
      _bmHealTimery.forEach(clearTimeout);
      _bmHealTimery = [450, 700, 1000, 1600].map(function (ms) {
        return setTimeout(bmHealCartList, ms);
      });
    });
  }

  function bindQuantityButtons() {
    /* Komponent Dawn żywy? Wtedy on obsługuje przyciski — nie dotykamy ich,
       bo drugi handler powodowałby zmianę o 2 zamiast o 1. */
    if (window.customElements && customElements.get('cart-quantity-selector-component')) return;

    document.querySelectorAll(
      'cart-quantity-selector-component .quantity-minus, cart-quantity-selector-component .quantity-plus'
    ).forEach(function (btn) {
      if (btn._bmQty) return;
      btn._bmQty = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var qs = btn.closest('cart-quantity-selector-component');
        if (!qs) return;
        var input = qs.querySelector('input[type="number"]');
        if (!input) return;

        var line = parseInt(input.getAttribute('data-cart-line'), 10);
        if (!line) return;

        var current = parseInt(input.value, 10) || 1;
        var step = parseInt(input.step, 10) || 1;
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 1;
        var isMinus = btn.classList.contains('quantity-minus') || btn.name === 'minus';
        var next = isMinus ? Math.max(min, current - step) : current + step;

        if (next === current) return;
        input.value = next;
        bmCartChange(line, next, input);
      });
    });
  }

  function resetScrollHint() {
    var sh = document.querySelector('scroll-hint');
    if (sh) sh.scrollTop = 0;
  }

  function watchCartButton() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    function onDrawerOpen() {
      [50, 200, 500, 1000].forEach(function(t) {
        setTimeout(function() {
          styleCartButton();
          forceCartStyles();
          bindQuantityButtons();
          resetScrollHint();
        }, t);
      });
    }

    /* Obserwuj tylko atrybut open — NIE subtree (blokuje +/−) */
    new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'open') onDrawerOpen();
      });
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });

    /* Obserwuj też dialog */
    var dialog = document.querySelector('dialog.cart-drawer__dialog');
    if (dialog) {
      new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'open') onDrawerOpen();
        });
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    styleCartButton();
    forceCartStyles();
    bindQuantityButtons();
    [300, 700, 1500].forEach(function(t) {
      setTimeout(function() { styleCartButton(); forceCartStyles(); }, t);
    });

    /* Obserwuj zmiany ZAWARTOŚCI szuflady (po update ilości Dawn morfuje DOM) */
    if (dialog) {
      var morphTimer = null;
      new MutationObserver(function() {
        clearTimeout(morphTimer);
        morphTimer = setTimeout(function() {
          forceCartStyles();
          bindQuantityButtons();
          styleCartButton();
        }, 200);
      }).observe(dialog, { childList: true, subtree: false });
    }

    document.addEventListener('CartAdd', function() {
      [200, 500, 1000].forEach(function(t) {
        setTimeout(function() { styleCartButton(); forceCartStyles(); bindQuantityButtons(); }, t);
      });
    });

    bmWatchCartRemoval();
  }


  /* ── CART PAGE — tytuł "Cart" → "Koszyk" + style ─────── */
  function injectCartPageCSS() {
    if (document.getElementById('bm-cart-page-injected')) return;
    /* Tylko na stronie /cart (nie w drawerze) */
    if (!window.location.pathname.startsWith('/cart')) return;
    var s = document.createElement('style');
    s.id = 'bm-cart-page-injected';
    s.textContent = [
      /* Tło strony koszyka */
      '.main-cart-items,.cart-wrapper,.cart-page,.template-cart main{background:transparent!important;}',
      /* CSS zmienne — eliminuje ciemne tło inputów */
      '.main-cart-items,.cart-form,.cart-wrapper{--color-input-background:transparent!important;--color-input-border:transparent!important;--style-border-radius-inputs:0px!important;--style-border-width-inputs:0px!important;}',
      /* Tytuł strony koszyka */
      '.cart__heading,.cart-page h1,.page-header h1,[class*="cart-page"] h1{font-family:"Bricolage Grotesque",sans-serif!important;font-size:1.6rem!important;font-weight:700!important;color:#fff!important;letter-spacing:-.02em!important;}',
      /* Usuń linie wewnątrz kart */
      '.cart-items__table-row *{border-top:none!important;border-bottom:none!important;}',
      /* Kolor tła koszyka — brak dodatkowych warstw */
      '.cart-items__table>thead{height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;}',
      /* Sekcja sum */
      '.cart-totals,.cart__summary-totals,[class*="cart-summary"]{border:none!important;border-top:none!important;}',
      /* Kontroler ilości — transparent */
      '.cart-items .quantity-selector-wrapper,.main-cart-items .quantity-selector-wrapper{background:transparent!important;border:none!important;}',
      '.cart-items cart-quantity-selector-component,.cart-items .quantity-selector{background:transparent!important;border:none!important;box-shadow:none!important;}',
      /* Przycisk checkout na stronie cart */
      '.cart__checkout-button,#checkout{background:linear-gradient(135deg,#d4b06a 0%,#c9a45c 55%,#b8894a 100%)!important;color:#0a0908!important;font-family:"Space Mono",monospace!important;font-size:.54rem!important;letter-spacing:.24em!important;text-transform:uppercase!important;font-weight:700!important;border:none!important;border-radius:6px!important;height:52px!important;}',
    ].join('\n');
    document.head.appendChild(s);
  }

  function fixCartPageTitle() {
    if (!window.location.pathname.startsWith('/cart')) return;
    /* Zmień "Cart" → "Koszyk" */
    var heading = document.querySelector('.cart__heading, h1.cart-page__heading, main h1');
    if (heading) {
      var txt = heading.textContent || heading.innerText || '';
      if (/^cart$/i.test(txt.trim()) || txt.trim() === 'Cart') {
        heading.textContent = 'Koszyk';
      }
    }
  }

  /* ── SHOP PAY / GOOGLE PAY — dopasowanie do ciemnego motywu ── */
  function styleAlternativePayments() {
    if (document.getElementById('bm-altpay-injected')) return;
    var s = document.createElement('style');
    s.id = 'bm-altpay-injected';
    s.textContent = [
      /* Wrapper sekcji płatności alternatywnych */
      '.shopify-payment-button,.dynamic-checkout-cart,.additional-checkout-buttons{opacity:.7!important;margin-top:.5rem!important;}',
      '.shopify-payment-button:hover,.dynamic-checkout-cart:hover{opacity:1!important;}',
      /* Ograniczenie rozmiarów przycisków */
      '.shopify-payment-button>div,.shopify-payment-button__button{height:44px!important;border-radius:6px!important;overflow:hidden!important;}',
      /* Separator nad przyciskami altpay */
      '.shopify-payment-button::before{content:"— lub zapłać przez —"!important;display:block!important;text-align:center!important;font-family:"Space Mono",monospace!important;font-size:.45rem!important;letter-spacing:.1em!important;color:rgba(255,255,255,.2)!important;margin-bottom:.5rem!important;text-transform:uppercase!important;}',
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── INIT ────────────────────────────────────────────── */
  function init() {
    /* forceHeaderFixed najpierw — niezależnie od reszty init() */
    try { forceHeaderFixed(); } catch(e) {}
    try { injectSearchModalCSS(); } catch(e) {}
    try { injectCartCSS(); } catch(e) {}
    try { injectCartPageCSS(); } catch(e) {}
    try { styleAlternativePayments(); } catch(e) {}
    try { watchCartButton(); } catch(e) {}
    replaceLogo_withRetry();
    injectCenteredNavLogo_withRetry();
    injectPaths();
    syncCartCount();
    lazyImageFade();
    styleHeroButtons();
    [300, 800].forEach(function (ms) { setTimeout(styleHeroButtons, ms); });
    markActiveNav();
    [400, 1200].forEach(function (ms) { setTimeout(markActiveNav, ms); });
    applyGoldNavHover();
    [300, 900].forEach(function (ms) { setTimeout(applyGoldNavHover, ms); });
    /* injectCartButtons() wyłączone — przyciski koszyka na kartach
       w katalogu zostały usunięte (brzydko wyglądały przy wariantach). */
    fixCartPageTitle();
    [300, 800].forEach(function (ms) { setTimeout(fixCartPageTitle, ms); });
    /* Ukryj header-menu na mobile (duplikuje navigation_bar) */
    if (window.innerWidth <= 749) {
      var _hm = document.querySelector('header-menu.header-menu, header-menu');
      if (_hm) _hm.style.setProperty('display', 'none', 'important');
      [200, 600, 1200].forEach(function(t) {
        setTimeout(function() {
          var hm = document.querySelector('header-menu.header-menu, header-menu');
          if (hm && window.innerWidth <= 749) hm.style.setProperty('display', 'none', 'important');
        }, t);
      });
    }
    fixSearchModalImages();
    watchConsentBanner();
    installScrollGuard();
    initHeaderScroll();
    watchMobileMenu();
    forceHeaderFixed();
    setTimeout(forceHeaderFixed, 500);
    [200, 800, 1600, 3200].forEach(function (ms) {
      setTimeout(function () { try { stripHeaderBackdrop(); } catch (e) {} }, ms);
    });
    try { watchHeaderBackdrop(); } catch (e) {}
  }

  /* Uruchom forceHeaderFixed niezależnie od init() */
  function runHeaderFixed() {
    try { forceHeaderFixed(); } catch(e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runHeaderFixed);
    document.addEventListener('DOMContentLoaded', init);
  } else {
    runHeaderFixed();
    init();
  }
  setTimeout(runHeaderFixed, 300);
  setTimeout(runHeaderFixed, 1000);

  document.addEventListener('shopify:section:load', replaceLogo_withRetry);
  document.addEventListener('page:load', init);
  document.addEventListener('turbo:load', init);

})();

/* ── HOMEPAGE DOM RESTRUCTURE ──────────────────────────────
   The compiled theme serves a frozen snapshot. We use JS
   to restructure the homepage DOM to match the reference.
─────────────────────────────────────────────────────────── */
(function() {
  function restructureHomepage() {
    /* Only run on homepage */
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;

    /* 1. Fix trust strip: replace 4 items with 3 correct items */
    var ts = document.querySelector('.trust-strip');
    if (ts) {
      ts.innerHTML = [
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
              '<circle cx="12" cy="12" r="10"/>',
              '<polyline points="12 6 12 12 16 14"/>',
            '</svg>',
          '</div>',
          '<div class="trust-item-label">Wysyłka w ciągu 24h<strong>Błyskawiczna realizacja zamówienia</strong></div>',
        '</div>',
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
              '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.95-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>',
            '</svg>',
          '</div>',
          '<div class="trust-item-label">Obsługa na poziomie<strong>Odpowiadamy 7 dni w tygodniu</strong></div>',
        '</div>',
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
              '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>',
              '<path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
            '</svg>',
          '</div>',
          '<div class="trust-item-label">Bezpieczna płatność<strong>Szyfrowane transakcje online</strong></div>',
        '</div>'
      ].join('');
      /* Update grid to 3 columns */
      ts.style.gridTemplateColumns = 'repeat(3, 1fr)';
    }

    /* 2. Move trust strip to AFTER collections section */
    var kolekcje = document.getElementById('kolekcje');
    if (kolekcje && ts && ts.parentNode) {
      kolekcje.parentNode.insertBefore(ts, kolekcje.nextSibling);
    }

    /* 3. Remove USP strip */
    var uspStrip = document.querySelector('.usp-strip');
    if (uspStrip) uspStrip.remove();

    /* 4. Fix brand section labels */
    var brandEyebrow = document.querySelector('#o-nas .sec-eyebrow');
    if (brandEyebrow && brandEyebrow.textContent.includes('Historia')) {
      brandEyebrow.textContent = 'O Nas';
    }
    var brandTitle = document.querySelector('#o-nas .sec-title');
    if (brandTitle && brandTitle.textContent.includes('Stworzona')) {
      brandTitle.innerHTML = 'Założona<br>z Pasją do Mody';
    }
    /* Fix brand stats */
    var brandStats = document.querySelector('#o-nas .brand-stats');
    if (brandStats) {
      var statItems = brandStats.querySelectorAll('div');
      if (statItems.length >= 3) {
        statItems[0].querySelector('.stat-val') && (statItems[0].querySelector('.stat-val').textContent = '5 TYS.+');
        statItems[0].querySelector('.stat-lbl') && (statItems[0].querySelector('.stat-lbl').textContent = 'Zadowolonych Klientek');
        statItems[1].querySelector('.stat-val') && (statItems[1].querySelector('.stat-val').textContent = '99%');
        statItems[1].querySelector('.stat-lbl') && (statItems[1].querySelector('.stat-lbl').textContent = 'Pozytywnych Opinii');
        if (statItems[2] && statItems[2].querySelector) statItems[2].remove();
      }
    }

    /* 5. Fix products section eyebrow */
    var nowosciEyebrow = document.querySelector('#nowosci .sec-eyebrow');
    if (nowosciEyebrow && nowosciEyebrow.textContent.includes('Arrivals')) {
      nowosciEyebrow.textContent = 'Prosto do Butiku';
    }

    /* 6. Add social media section before newsletter */
    var nlSection = document.querySelector('.nl-section');
    var fbUrl = 'https://www.facebook.com/butikmadamea/?locale=pl_PL';
    var ttUrl = 'https://www.tiktok.com/@_butik_madame_a_';
    if (nlSection && !document.getElementById('bm-social-section')) {
      var socHtml = '<section id="bm-social-section" style="background:var(--bg-dark);border-top:1px solid var(--gold-border);padding:5rem var(--page-pad,4rem);text-align:center">' +
        '<div class="sec-eyebrow centered" style="font-family:Space Mono,monospace;font-size:.55rem;letter-spacing:.22em;text-transform:uppercase;color:var(--gold);margin-bottom:.75rem">Dołącz do Społeczności</div>' +
        '<h2 style="font-family:Bricolage Grotesque,sans-serif;font-size:clamp(1.6rem,3.5vw,2.4rem);font-weight:700;color:#fff;margin:0 auto 1rem;letter-spacing:-.02em">Obserwuj <em style="color:var(--gold);font-style:normal">Butik Madame A</em></h2>' +
        '<p style="color:var(--text-muted,rgba(255,255,255,.5));margin:0 auto 2.5rem;max-width:520px;font-size:.82rem;line-height:1.7">Bądź na bieżąco z nowościami, inspiracjami i ekskluzywnymi ofertami.</p>' +
        '<div style="display:flex;justify-content:center;gap:1.5rem;flex-wrap:wrap">' +
          '<a href="' + ttUrl + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:.6rem;padding:.85rem 2.2rem;background:#111;color:#fff;border:1.5px solid rgba(255,255,255,.2);border-radius:3px;font-family:Space Mono,monospace;font-size:.6rem;letter-spacing:.15em;text-transform:uppercase;font-weight:700;text-decoration:none;transition:transform .18s cubic-bezier(.34,1.56,.64,1)">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" width="18" height="18"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34l-.02-8.62a8.16 8.16 0 004.77 1.52V7.74a4.85 4.85 0 01-.98-.05z"/></svg>' +
            'TikTok' +
          '</a>' +
          '<a href="' + fbUrl + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:.6rem;padding:.85rem 2.2rem;background:#c9a45c;color:#1a1918;border:1.5px solid #c9a45c;border-radius:3px;font-family:Space Mono,monospace;font-size:.6rem;letter-spacing:.15em;text-transform:uppercase;font-weight:700;text-decoration:none;transition:transform .18s cubic-bezier(.34,1.56,.64,1)">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>' +
            'Facebook' +
          '</a>' +
        '</div>' +
      '</section>';
      nlSection.insertAdjacentHTML('beforebegin', socHtml);
    }

    /* 7. Move newsletter BEFORE testimonials (currently reviews come before nl) */
    var opinie = document.getElementById('opinie');
    if (nlSection && opinie && opinie.parentNode) {
      var nlNext = nlSection.nextElementSibling;
      if (nlNext !== opinie) {
        opinie.parentNode.insertBefore(nlSection, opinie);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restructureHomepage);
  } else {
    restructureHomepage();
  }
  document.addEventListener('page:load', restructureHomepage);
  document.addEventListener('turbo:load', restructureHomepage);
})();

/* ── NAV BAR COLOR FIX ─────────────────────────────────────
   Ensures menu-list--mobile (nav row) shows same dark background
   as the top header row on ALL pages. Bypasses Dawn color scheme
   CSS that makes the nav row lighter. Runs independently of
   the inline theme.liquid script to bypass CDN HTML cache.
────────────────────────────────────────────────────────── */
(function() {
  var BG = '#1a1918';
  function fixNavBarColors() {
    document.querySelectorAll('#header-group .search-action--hidden-on-drawer').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
    var hc = document.querySelector('header-component');
    if (hc) {
      hc.style.setProperty('--color-scheme-bottom-row', BG);
      hc.style.setProperty('--color-scheme-top-row', BG);
    }
    document.querySelectorAll(
      '#header-group .menu-list, #header-group .menu-list--mobile, ' +
      '#header-group [class*="color-scheme-1"], #header-group [class*="color-scheme-2"], ' +
      '#header-group .header__navigation-bar-row, #header-group .header__underlay-closed'
    ).forEach(function(el) {
      el.style.setProperty('background', BG, 'important');
      el.style.setProperty('background-color', BG, 'important');
      el.style.setProperty('background-image', 'none', 'important');
    });
    try {
      var s = document.getElementById('bm-nav-color-fix');
      if (!s) { s = document.createElement('style'); s.id = 'bm-nav-color-fix'; document.body.appendChild(s); }
      s.textContent = '#header-group .menu-list,#header-group .menu-list--mobile,' +
        '#header-group .header__navigation-bar-row,#header-group .header__underlay-closed,' +
        '#header-group [class*="color-scheme-1"],#header-group [class*="color-scheme-2"]' +
        '{background:#1a1918!important;background-color:#1a1918!important;background-image:none!important}';
    } catch(e) {}
  }

  function init() {
    fixNavBarColors();
    [100, 300, 700, 1500, 3000].forEach(function(ms) { setTimeout(fixNavBarColors, ms); });
    if (window.MutationObserver) {
      var hg = document.querySelector('#header-group');
      if (hg) {
        new MutationObserver(function(muts) {
          if (muts.some(function(m) { return m.addedNodes.length > 0; })) setTimeout(fixNavBarColors, 50);
        }).observe(hg, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('page:load', init);
  document.addEventListener('turbo:load', init);
})();


/* ═══════════════════════════════════════════════════════════════════
   DOSTAWA — pasek darmowej wysyłki + skierowanie na krok wyboru dostawy
   ───────────────────────────────────────────────────────────────────
   Sam wybór metody (paczkomat / kurier / odbiór w butiku), mapa punktów
   InPost i dane do wysyłki żyją na osobnej stronie /pages/dostawa
   (sekcja sections/bm-delivery.liquid). Tutaj zostaje tylko pasek
   postępu do darmowej dostawy i przekierowanie z przycisku zakupu.

   Dlaczego osobna strona, a nie blok w checkoucie: plan Basic nie ma
   dostępu do Pickup Point Delivery Option Generator API — to Plus.

   Szybkie płatności (Apple Pay / Google Pay / Shop Pay) są w koszyku
   ukryte, bo prowadzą prosto do płatności z pominięciem wyboru dostawy.
   Nic przez to nie tracimy — checkout i tak pokazuje je na górze
   jako „Ekspresowa realizacja zakupu".
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STEP_URL = '/pages/dostawa';

  var stepExists = null;   /* null = jeszcze nie sprawdzone */

  /* ── STYLE ─────────────────────────────────────────────────────
     Koszyk żyje w #header-group, gdzie działają reguły z ID
     (#header-group button{color:...!important}), więc selektory mają
     wariant z #header-group. Nazwy klas omijają wildcardy
     [class*="..."] z bm-styles.css — patrz CLAUDE.md.            */
  function injectCSS() {
    if (document.getElementById('bm-ship-css')) return;
    var s = document.createElement('style');
    s.id = 'bm-ship-css';
    s.textContent = [
      /* Wszystko z !important — motyw narzuca rozmiar tekstu w koszyku
         i bez tego pasek dziedziczył 14 px zamiast zadanych 11 px. */
      '.bm-ship{display:block!important;width:100%!important;margin:0 0 14px!important;',
      'font-family:"Space Mono",monospace!important;}',
      '.bm-ship__text{display:block!important;font-size:11px!important;line-height:1.4!important;',
      'letter-spacing:.04em!important;color:#cfc7b4!important;margin-bottom:6px!important;}',
      '.bm-ship__text b{color:#c9a45c!important;font-weight:700!important;}',
      '.bm-ship__bar{display:block!important;height:4px!important;width:100%!important;',
      'background:rgba(201,164,92,.28)!important;border-radius:2px!important;overflow:hidden!important;}',
      '.bm-ship__bar i{display:block!important;height:100%!important;background:#c9a45c!important;',
      'border-radius:2px!important;transition:width .35s ease!important;}',
      '.bm-ship--done .bm-ship__text{color:#c9a45c!important;}',
      '.bm-ship__next{display:block!important;font-size:10px!important;line-height:1.4!important;',
      'letter-spacing:.1em!important;text-transform:uppercase!important;',
      'color:rgba(236,231,220,.42)!important;margin-top:9px!important;}',
      '.bm-ship__next[hidden]{display:none!important;}',

      /* Kody rabatowe wyłączone — sekcja zabierała 56 px w szufladzie.
         Żeby wrócić: usuń tę regułę (pole samo się pokaże). */
      '.cart-discount,cart-discount-component,.cart-actions__divider{display:none!important;}',
      '.cart-actions:not(:has(cart-note)){display:none!important;border:none!important;}',

      /* Szybkie płatności omijają wybór dostawy — w koszyku ich nie ma */
      '.bm-ship-solo .additional-checkout-buttons,',
      '.bm-ship-solo .shopify-payment-button{display:none!important;}',

      /* Telefon: szuflada jest ciasna, więc pasek chudnie na rzecz pozycji */
      '@media (max-width:749px){',
      '  .bm-ship{margin:0 0 8px!important;}',
      '  .bm-ship__text{font-size:10px!important;margin-bottom:4px!important;}',
      '  .bm-ship__bar{height:3px!important;}',
      '  .bm-ship__next{font-size:8.5px!important;margin-top:5px!important;letter-spacing:.06em!important;}',
      '  .cart-totals__tax-note{font-size:9px!important;line-height:1.35!important;}',
      '  .cart-totals__tax-note small{font-size:9px!important;}',
      '  .cart-drawer__summary .cart-totals{gap:5px!important;}',
      '  .cart-drawer__summary{padding-block:8px!important;}',
      '}',

      /* Kody rabatowe wyłączone — sekcja zabierała 56 px w szufladzie.
         Żeby wrócić: usuń tę regułę (pole samo się pokaże). */
      '.cart-discount,cart-discount-component,.cart-actions__divider{display:none!important;}',
      '.cart-actions:not(:has(cart-note)){display:none!important;border:none!important;}',

      /* Szybkie płatności omijają wybór dostawy — w koszyku ich nie ma */
      '.bm-ship-solo .additional-checkout-buttons,',
      '.bm-ship-solo .shopify-payment-button{display:none!important;}',

      /* Nakładka z krokiem dostawy — używana, gdy w panelu nie ma strony
         /pages/dostawa. Treść pobieramy z tej samej sekcji motywu, więc
         jest jedno źródło prawdy niezależnie od drogi wejścia. */
      'dialog.bm-step{position:fixed!important;inset:0!important;width:100%!important;',
      'max-width:100%!important;height:100%!important;max-height:100%!important;',
      'margin:0!important;padding:0!important;border:none!important;border-radius:0!important;',
      'background:#1a1918!important;color:#ece7dc!important;overflow:hidden auto!important;}',
      'dialog.bm-step[open]{display:block!important;}',
      'dialog.bm-step::backdrop{background:#1a1918;}',
      '.bm-step__load{display:flex;align-items:center;justify-content:center;min-height:60vh;',
      'font-family:"Space Mono",monospace;font-size:11px;letter-spacing:.1em;',
      'text-transform:uppercase;color:rgba(201,164,92,.7);}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* Strona kroku dostawy powstaje w panelu (Sklep internetowy → Strony).
     Dopóki jej nie ma, przycisk zakupu ma prowadzić prosto do checkoutu,
     żeby nie wysyłać klientek na 404. */
  function checkStep(cb) {
    if (stepExists !== null) { cb(stepExists); return; }
    fetch(STEP_URL, { method: 'HEAD' })
      .then(function (r) { stepExists = r.ok; cb(stepExists); })
      .catch(function () { stepExists = false; cb(false); });
  }

  /* ── PASEK W KOSZYKU ───────────────────────────────────────────── */
  /* Pasek postępu do darmowej dostawy usunięty — sklep nie ma progu
     darmowej wysyłki. Zostaje sama informacja, że dostawę wybiera się dalej. */
  function buildBar() {
    var w = document.createElement('div');
    w.className = 'bm-ship';
    w.innerHTML = '<span class="bm-ship__next">Dostawę wybierzesz w następnym kroku</span>';
    return w;
  }

  function paint(bar) {
    bar.querySelector('.bm-ship__next').hidden = false;
  }

  function gateFast(ctas) {
    var host = ctas.closest('.cart-summary__inner, .cart-drawer__summary, .cart-page__summary')
      || ctas.parentNode;
    if (!host || !host.classList) return;
    host.classList.add('bm-ship-solo');
  }

  function render() {
    var ctas = document.querySelectorAll('.cart__ctas');
    if (!ctas.length) return;
    injectCSS();
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      var bar = c.previousElementSibling;
      if (!bar || !bar.classList || !bar.classList.contains('bm-ship')) {
        bar = buildBar();
        c.parentNode.insertBefore(bar, c);
      }
      paint(bar);
      gateFast(c);
    }
  }

  /* ── PRZEKIEROWANIE NA KROK DOSTAWY ────────────────────────────
     Listener w fazie przechwytywania, żeby wyprzedzić submit
     formularza koszyka w Dawn.                                     */
  /* Nakładka na wypadek braku strony w panelu.
     Sekcję pobieramy przez Section Rendering API, więc UI jest dokładnie
     to samo, co na /pages/dostawa — nie ma drugiej kopii do utrzymania.
     UWAGA: <script> wstawiony przez innerHTML NIE wykonuje się,
     trzeba go odtworzyć jako nowy element. */
  function openOverlay() {
    var d = document.getElementById('bm-step');
    if (d) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } return; }

    d = document.createElement('dialog');
    d.id = 'bm-step';
    d.className = 'bm-step';
    d.innerHTML = '<div class="bm-step__load">Wczytuję krok dostawy…</div>';
    document.body.appendChild(d);
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }

    fetch('/?section_id=bm-delivery')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        d.innerHTML = html;
        Array.prototype.forEach.call(d.querySelectorAll('script'), function (old) {
          var n = document.createElement('script');
          if (old.src) n.src = old.src; else n.textContent = old.textContent;
          old.parentNode.replaceChild(n, old);
        });
        var back = d.querySelector('.bmd-back');
        if (back) {
          back.addEventListener('click', function (ev) {
            ev.preventDefault();
            try { d.close(); } catch (e) {}
          });
        }
      })
      .catch(function () {
        d.innerHTML = '<div class="bm-step__load">Nie udało się wczytać. Odśwież stronę.</div>';
      });
  }

  function guardCheckout() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('#checkout, .cart__checkout-button, [name="checkout"]')) return;
      e.preventDefault();
      e.stopPropagation();
      /* Strona w panelu jest opcjonalna: gdy jest — pełny adres,
         gdy jej nie ma — ta sama sekcja jako nakładka. */
      var go = function () {
        if (stepExists) window.location.href = STEP_URL;
        else openOverlay();
      };
      /* Najpierw okienko z propozycjami (IIFE niżej); samo woła go(),
         gdy nie ma czego pokazać albo klientka idzie dalej. */
      if (window.bmUpsell) window.bmUpsell(go);
      else go();
    }, true);
  }

  /* Nie obserwujemy szuflady koszyka przez MutationObserver —
     childList/subtree na cart-drawer psuje zdarzenia +/- w Dawn
     (patrz CLAUDE.md). Zamiast tego lekki sondaż. */
  function watch() {
    setInterval(function () {
      if (!document.querySelector('.cart__ctas')) return;
      if (!document.querySelector('.bm-ship')) render();
    }, 800);

    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { render(); });
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a[href*="/cart"], .header-actions__cart-icon, cart-drawer-component, [data-cart-drawer]')) {
        [120, 400, 900].forEach(function (ms) { setTimeout(function () { render(); }, ms); });
      }
    }, true);
  }

  function boot() {
    injectCSS();
    guardCheckout();
    checkStep(function () {
      render();
      watch();
      [500, 1500].forEach(function (ms) { setTimeout(function () { render(); }, ms); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ═══════════════════════════════════════════════════════════════════
   PROPOZYCJE PRZED DOSTAWĄ — okienko „Może jeszcze coś do kompletu?"
   ───────────────────────────────────────────────────────────────────
   Wywoływane z guardCheckout() (blok wyżej) jako window.bmUpsell(go).
   Pokazuje do 3 produktów z rekomendacji Shopify
   (/recommendations/products.json, intent=related) dla produktów
   z koszyka, z pominięciem tych, które już w nim są.

   Zasady:
   - raz na wizytę (sessionStorage) — klientka wracająca z kroku dostawy
     nie dostaje okienka drugi raz;
   - nie ma propozycji / sieć nie odpowiada w 2,5 s → od razu go(),
     okienko nigdy nie blokuje zakupu;
   - dodanie produktu odświeża koszyk pod spodem (window.bmCartSync).

   Klasy z prefiksem bm-ups omijają wildcardy [class*="..."] z motywu
   (cart, card, btn, title, name, price, close, modal… — patrz CLAUDE.md).
   Dialog żyje w <body>, nie w #header-group, ale motyw i tak stylizuje
   gołe button/select/img — stąd !important.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var KLUCZ = 'bm-ups-shown';
  var ILE = 3;
  var LIMIT_MS = 2500;
  var shownMem = false;      /* zapas, gdy sessionStorage rzuca */
  var busy = false;

  function wasShown() {
    if (shownMem) return true;
    try { return sessionStorage.getItem(KLUCZ) === '1'; } catch (e) { return false; }
  }
  function markShown() {
    shownMem = true;
    try { sessionStorage.setItem(KLUCZ, '1'); } catch (e) {}
  }

  function zl(grosze) {
    return (grosze / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function injectCSS() {
    if (document.getElementById('bm-ups-css')) return;
    var s = document.createElement('style');
    s.id = 'bm-ups-css';
    s.textContent = [
      'dialog.bm-ups{position:fixed!important;margin:auto!important;padding:0!important;',
      'width:min(520px,calc(100% - 32px))!important;max-width:520px!important;max-height:calc(100% - 32px)!important;',
      'border:1px solid rgba(201,164,92,.28)!important;border-radius:14px!important;',
      'background:#14120f!important;color:#ece7dc!important;overflow:hidden auto!important;',
      'box-shadow:0 24px 70px rgba(0,0,0,.6),0 0 0 1px rgba(201,164,92,.06),0 8px 40px rgba(201,164,92,.10)!important;',
      'opacity:0;transform:translateY(14px);transition:opacity .22s ease,transform .22s ease;}',
      'dialog.bm-ups[open]{display:block!important;}',
      'dialog.bm-ups.bm-ups--in{opacity:1;transform:none;}',
      'dialog.bm-ups::backdrop{background:rgba(8,7,6,.72);}',
      '.bm-ups__box{padding:22px 20px 18px!important;font-family:"Space Mono",monospace!important;}',
      '.bm-ups__head{display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:12px!important;margin-bottom:16px!important;}',
      '.bm-ups__lead{display:block!important;font-family:"Bricolage Grotesque",sans-serif!important;font-size:21px!important;',
      'line-height:1.15!important;letter-spacing:-.02em!important;font-weight:700!important;color:#ece7dc!important;margin:0!important;}',
      '.bm-ups__sub{display:block!important;font-size:10.5px!important;letter-spacing:.06em!important;',
      'color:rgba(236,231,220,.5)!important;margin-top:6px!important;line-height:1.45!important;}',
      'dialog.bm-ups .bm-ups__x{flex:0 0 auto!important;width:40px!important;height:40px!important;min-height:40px!important;',
      'display:flex!important;align-items:center!important;justify-content:center!important;padding:0!important;margin:-8px -8px 0 0!important;',
      'background:transparent!important;border:none!important;border-radius:50%!important;color:#c9a45c!important;cursor:pointer!important;',
      'font-size:24px!important;line-height:1!important;opacity:1!important;animation:none!important;transition:transform .15s ease!important;}',
      'dialog.bm-ups .bm-ups__x:hover{transform:rotate(90deg)!important;}',
      'dialog.bm-ups .bm-ups__x:focus-visible{outline:2px solid #c9a45c!important;outline-offset:2px!important;}',
      '.bm-ups__list{display:flex!important;flex-direction:column!important;gap:10px!important;margin:0 0 18px!important;padding:0!important;}',
      '.bm-ups__item{display:grid!important;grid-template-columns:72px 1fr!important;gap:12px!important;align-items:center!important;',
      'padding:10px!important;border-radius:10px!important;background:rgba(255,255,255,.03)!important;',
      'border:1px solid rgba(201,164,92,.12)!important;}',
      '.bm-ups__pic{display:block!important;width:72px!important;height:90px!important;border-radius:6px!important;overflow:hidden!important;background:#221f1b!important;}',
      'dialog.bm-ups .bm-ups__pic img{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;border-radius:0!important;}',
      '.bm-ups__info{display:flex!important;flex-direction:column!important;gap:6px!important;min-width:0!important;}',
      'dialog.bm-ups a.bm-ups__nm{display:block!important;font-size:12px!important;line-height:1.35!important;color:#ece7dc!important;',
      'text-decoration:none!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;background:transparent!important;}',
      'dialog.bm-ups a.bm-ups__nm:hover{color:#c9a45c!important;}',
      '.bm-ups__cost{display:block!important;font-size:12px!important;font-weight:700!important;color:#c9a45c!important;}',
      '.bm-ups__row2{display:flex!important;gap:8px!important;align-items:center!important;}',
      'dialog.bm-ups select.bm-ups__pick{flex:1 1 auto!important;min-width:0!important;height:36px!important;padding:0 8px!important;',
      'font-family:"Space Mono",monospace!important;font-size:11px!important;color:#ece7dc!important;',
      'background:#1d1a16!important;border:1px solid rgba(201,164,92,.3)!important;border-radius:6px!important;}',
      'dialog.bm-ups .bm-ups__add{flex:0 0 auto!important;height:36px!important;min-height:36px!important;padding:0 14px!important;',
      'font-family:"Space Mono",monospace!important;font-size:10px!important;letter-spacing:.14em!important;text-transform:uppercase!important;font-weight:700!important;',
      'color:#c9a45c!important;background:transparent!important;border:1px solid #c9a45c!important;border-radius:6px!important;cursor:pointer!important;',
      'transition:transform .12s ease,opacity .15s ease!important;}',
      'dialog.bm-ups .bm-ups__add:hover{color:#0a0908!important;background:#c9a45c!important;}',
      'dialog.bm-ups .bm-ups__add:active{transform:scale(.96)!important;}',
      'dialog.bm-ups .bm-ups__add:focus-visible{outline:2px solid #e2d69a!important;outline-offset:2px!important;}',
      'dialog.bm-ups .bm-ups__add[disabled]{cursor:default!important;opacity:.85!important;}',
      'dialog.bm-ups .bm-ups__add.bm-ups--ok{color:#0a0908!important;background:#c9a45c!important;}',
      'dialog.bm-ups .bm-ups__go{display:block!important;width:100%!important;height:52px!important;border:none!important;border-radius:6px!important;',
      'background:linear-gradient(135deg,#d4b06a 0%,#c9a45c 55%,#b8894a 100%)!important;color:#0a0908!important;',
      'font-family:"Space Mono",monospace!important;font-size:11px!important;letter-spacing:.2em!important;text-transform:uppercase!important;font-weight:700!important;',
      'box-shadow:0 4px 28px rgba(201,164,92,.35)!important;cursor:pointer!important;transition:transform .12s ease,box-shadow .2s ease!important;}',
      'dialog.bm-ups .bm-ups__go:hover{box-shadow:0 8px 36px rgba(201,164,92,.5)!important;}',
      'dialog.bm-ups .bm-ups__go:active{transform:scale(.98)!important;}',
      'dialog.bm-ups .bm-ups__go:focus-visible{outline:2px solid #e2d69a!important;outline-offset:3px!important;}',
      '.bm-ups__err{display:block!important;font-size:10px!important;color:#e08a7a!important;}',
      '.bm-ups__err[hidden]{display:none!important;}',
      /* Telefon: arkusz od dołu, kciuk sięga przycisków */
      '@media (max-width:749px){',
      '  dialog.bm-ups{margin:auto 0 0!important;width:100%!important;max-width:100%!important;max-height:88%!important;',
      '    border-radius:16px 16px 0 0!important;border-bottom:none!important;transform:translateY(40px);}',
      '  .bm-ups__box{padding:18px 16px calc(16px + env(safe-area-inset-bottom))!important;}',
      '  .bm-ups__lead{font-size:19px!important;}',
      '}',
      '@media (prefers-reduced-motion:reduce){dialog.bm-ups{transition:none!important;}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  /* Rekomendacje dla maks. 2 różnych produktów z koszyka, scalone. */
  function loadOffers() {
    return getJSON('/cart.js').then(function (cart) {
      var w = {};
      (cart.items || []).forEach(function (i) { w[i.product_id] = true; });
      var ids = Object.keys(w).slice(0, 2);
      if (!ids.length) return [];
      return Promise.all(ids.map(function (id) {
        return getJSON('/recommendations/products.json?intent=related&limit=8&product_id=' + id)
          .then(function (d) { return d.products || []; })
          .catch(function () { return []; });
      })).then(function (listy) {
        var out = [], byl = {};
        /* na przemian z obu list, żeby obie pozycje koszyka miały głos */
        for (var k = 0; k < 8 && out.length < ILE; k++) {
          listy.forEach(function (l) {
            var p = l[k];
            if (!p || out.length >= ILE || w[p.id] || byl[p.id]) return;
            var dost = (p.variants || []).filter(function (v) { return v.available; });
            if (!dost.length) return;
            byl[p.id] = true;
            out.push({ p: p, warianty: dost });
          });
        }
        return out;
      });
    });
  }

  function cartSectionId() {
    var c = document.querySelector('cart-items-component[data-section-id]');
    return c ? c.getAttribute('data-section-id') : null;
  }

  function addToCart(variantId, btn, err) {
    if (btn.disabled) return;
    btn.disabled = true;
    err.hidden = true;
    btn.textContent = '…';
    var sid = cartSectionId();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        btn.textContent = 'Dodano ✓';
        btn.classList.add('bm-ups--ok');
        var html = d && d.sections && sid ? d.sections[sid] : null;
        return getJSON('/cart.js').then(function (c) {
          if (window.bmCartSync) window.bmCartSync(html, c.item_count);
        }).catch(function () {});
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = 'Dodaj';
        err.textContent = (e && e.description) || 'Nie udało się dodać. Spróbuj jeszcze raz.';
        err.hidden = false;
      });
  }

  function buildItem(o) {
    var p = o.p;
    var li = el('div', 'bm-ups__item');

    var pic = el('a', 'bm-ups__pic');
    var href = p.url || ('/products/' + p.handle);
    pic.href = href;
    var src = p.featured_image || (p.images && p.images[0]);
    if (src) {
      var im = document.createElement('img');
      im.src = imgUrl(src, 180);
      im.alt = p.title;
      im.loading = 'lazy';
      pic.appendChild(im);
    }
    li.appendChild(pic);

    var info = el('div', 'bm-ups__info');
    var nm = el('a', 'bm-ups__nm', p.title);
    nm.href = href;
    info.appendChild(nm);
    var cost = el('span', 'bm-ups__cost', zl(o.warianty[0].price));
    info.appendChild(cost);

    var row = el('div', 'bm-ups__row2');
    var pick = null;
    var jedyny = o.warianty.length === 1 && /^default title$/i.test(o.warianty[0].title || '');
    if (o.warianty.length > 1 || !jedyny) {
      pick = document.createElement('select');
      pick.className = 'bm-ups__pick';
      pick.setAttribute('aria-label', 'Wariant: ' + p.title);
      o.warianty.forEach(function (v) {
        var op = document.createElement('option');
        op.value = v.id;
        op.textContent = v.title;
        pick.appendChild(op);
      });
      pick.addEventListener('change', function () {
        var v = o.warianty.filter(function (x) { return String(x.id) === pick.value; })[0];
        if (v) cost.textContent = zl(v.price);
      });
      /* przy jednym wariancie bez wyboru i tak pokazujemy, co to jest */
      if (o.warianty.length === 1) pick.disabled = true;
      row.appendChild(pick);
    }
    var add = el('button', 'bm-ups__add', 'Dodaj');
    add.type = 'button';
    var err = el('span', 'bm-ups__err');
    err.hidden = true;
    add.addEventListener('click', function () {
      addToCart(pick ? pick.value : o.warianty[0].id, add, err);
    });
    row.appendChild(add);
    info.appendChild(row);
    info.appendChild(err);
    li.appendChild(info);
    return li;
  }

  function show(offers, go) {
    injectCSS();
    var old = document.getElementById('bm-ups');
    if (old) old.remove();

    var d = document.createElement('dialog');
    d.id = 'bm-ups';
    d.className = 'bm-ups';
    d.setAttribute('aria-labelledby', 'bm-ups-lead');

    var box = el('div', 'bm-ups__box');
    var head = el('div', 'bm-ups__head');
    var txt = el('div');
    var lead = el('span', 'bm-ups__lead', 'Może jeszcze coś do kompletu?');
    lead.id = 'bm-ups-lead';
    txt.appendChild(lead);
    txt.appendChild(el('span', 'bm-ups__sub', 'Kilka rzeczy, które pasują do Twojego koszyka.'));
    head.appendChild(txt);
    var x = el('button', 'bm-ups__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Wróć do koszyka');
    head.appendChild(x);
    box.appendChild(head);

    var list = el('div', 'bm-ups__list');
    offers.forEach(function (o) { list.appendChild(buildItem(o)); });
    box.appendChild(list);

    var goBtn = el('button', 'bm-ups__go', 'Przejdź do dostawy →');
    goBtn.type = 'button';
    box.appendChild(goBtn);
    d.appendChild(box);
    document.body.appendChild(d);

    function zamknij() {
      d.classList.remove('bm-ups--in');
      setTimeout(function () { try { d.close(); } catch (e) {} d.remove(); }, 200);
    }
    x.addEventListener('click', zamknij);
    d.addEventListener('cancel', function (e) { e.preventDefault(); zamknij(); });
    d.addEventListener('click', function (e) { if (e.target === d) zamknij(); });  /* klik w tło */
    goBtn.addEventListener('click', function () {
      try { d.close(); } catch (e) {}
      d.remove();
      go();
    });

    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('bm-ups--in'); }); });
    goBtn.focus();
  }

  window.bmUpsell = function (go) {
    if (wasShown()) { go(); return; }
    if (busy) return;
    busy = true;
    withTimeout(loadOffers(), LIMIT_MS)
      .then(function (offers) {
        busy = false;
        if (!offers.length) { go(); return; }
        markShown();
        show(offers, go);
      })
      .catch(function () { busy = false; go(); });
  };
})();

/* ═══════════════════════════════════════════════════════════════════
   SZYBKIE DODAWANIE ZE STRONY GŁÓWNEJ — otwarcie szuflady koszyka
   ───────────────────────────────────────────────────────────────────
   Sam AJAX robi już <product-form-component> (patrz sections/
   homepage-custom.liquid). Szufladę Dawn otwiera jednak TYLKO gdy
   motyw ma włączone ustawienie `auto_open_cart_drawer` —
   assets/cart-drawer.js sprawdza atrybut `auto-open`. Gdyby ktoś
   wyłączył to w edytorze, produkt wpadałby do koszyka po cichu.

   Dlatego domykamy to sami, ale WYŁĄCZNIE dla kafli ze strony głównej
   (zdarzenie musi pochodzić z `.prod-quick`) — karty produktu i reszta
   motywu zostają na własnej logice. `showDialog()` sam wychodzi, gdy
   dialog jest już otwarty, więc podwójne wywołanie nic nie psuje.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('cart:update', function (e) {
    var src = e.target;
    if (!src || !src.closest || !src.closest('.prod-quick')) return;
    if (e.detail && e.detail.data && e.detail.data.didError) return;

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;

    /* Odrobina zwłoki: Dawn najpierw podmienia zawartość szuflady
       (morphSection w cart-items-component), a dopiero potem ma sens
       ją pokazywać — inaczej mignie stara lista. */
    setTimeout(function () {
      try { drawer.open(); } catch (err) { /* dialog już otwarty */ }
    }, 60);
  });
})();
